(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _socialToolbar = __webpack_require__(16);
	
	var _socialToolbar2 = _interopRequireDefault(_socialToolbar);
	
	var _stickyKit = __webpack_require__(12);
	
	var _menus = __webpack_require__(13);
	
	var _stickyHeader = __webpack_require__(15);
	
	var _sectionLoadUtils = __webpack_require__(10);
	
	var _sectionLoadUtils2 = _interopRequireDefault(_sectionLoadUtils);
	
	var _teInteresa = __webpack_require__(5);
	
	var _teInteresa2 = _interopRequireDefault(_teInteresa);
	
	var _pushNotificationIndigitall = __webpack_require__(8);
	
	var _vamDebug = __webpack_require__(7);
	
	var _vamDebug2 = _interopRequireDefault(_vamDebug);
	
	var _vocuserNotifications = __webpack_require__(14);
	
	var _additionaldataScript = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	Logger.debug('script layout loaded');
	
	/** get main vars **************************************************************************/
	var app = Voonto.getInstance();
	var feature = window.nibara.feature;
	
	var libPath = app.lookup('vocento.config.nibara').libPath;
	if (libPath === undefined) {
	  throw 'nibara libPath config is empty';
	}
	
	/** Menu absoluto abcblogs.abc.es **/
	var host = window.location.host;
	Logger.debug('[ABCBlogs] change path menu > host: ' + host);
	if ('abcblogs.abc.es' === host) {
	  Voonto.$('.primer-nivel li a').each(function () {
	    var href = Voonto.$(this).attr('href');
	    Logger.debug('[ABCBlogs] change path menu: ' + href);
	    if (href.indexOf('https://') == -1 && href.indexOf('http://') == -1) {
	      Voonto.$(this).attr('href', 'https://www.abc.es' + href);
	    }
	  });
	
	  Voonto.$('.segundo-nivel li a').each(function () {
	    var href = Voonto.$(this).attr('href');
	    Logger.debug('[ABCBlogs] change path menu: ' + href);
	    if (href.indexOf('https://') == -1 && href.indexOf('http://') == -1) {
	      Voonto.$(this).attr('href', 'https://www.abc.es' + href);
	    }
	  });
	}
	
	/** btn up *********************************************************************************/
	Voonto.$('.boton.subir.suave').click(function () {
	  var target = Voonto.$('[name=top]');
	  if (target) {
	    Voonto.$('html,body').animate({
	      scrollTop: target.offset().top
	    }, 2000);
	    return false;
	  }
	});
	
	/** image lazyload **************************************************************************/
	Voonto.lazyLoad = new LazyLoad({
	  elements_selector: ".lzld",
	  data_src: "src"
	});
	
	Voonto.$('.lzld-scroll').on('click', function (ev) {
	  Voonto.lazyLoad.handleScroll();
	});
	
	/** Menus ***********************************************************************************/
	if (Voonto.is.mobile()) {
	  Logger.info('Load menu mobile');
	  (0, _menus.menusMobile)();
	} else if (Voonto.is.tablet()) {
	  if (vocento.tracking.comscore.voc_tc !== 'portada' && vocento.tracking.comscore.voc_tc !== 'portadilla') {
	    Logger.info('Load menu mobile in news');
	    (0, _menus.menusMobile)();
	  } else {
	    Logger.info('Load menu desktop in home');
	    (0, _menus.menusDesktop)();
	  }
	} else {
	  Logger.info('Load menu desktop in home');
	  (0, _menus.menusDesktop)();
	}
	
	/** sticky header ***************************************************************************/
	if (Voonto.is.mobile()) {
	  (0, _stickyHeader.stickyHeaderMobile)();
	} else {
	  (0, _stickyHeader.stickyHeaderDesktop)();
	}
	
	if (Voonto.is.tablet()) {
	  app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(function () {
	    Voonto.$('[data-sticky]').stick_in_parent({
	      offset_top: 20,
	      spacer: false
	    });
	  });
	}
	
	/** tracking sticky mobile buttons ************************************************/
	if (Voonto.is.mobile() || Voonto.is.tablet()) {
	  Voonto.SocialToolbar = new _socialToolbar2.default();
	  var $stickyAds = Voonto.$('.publi-sticky');
	
	  Voonto.$('.publi-sticky.sticky > .botones.cerrar').on('click', function () {
	    Voonto.SocialToolbar.enable();
	  });
	
	  $stickyAds.on('click', function () {
	    Voonto.$(this).hide();
	  });
	
	  /**
	   * show Ads sticky when detect scroll
	   * @type {boolean}
	   */
	  var delay = false;
	  Voonto.$(window).on("scroll", function () {
	    if (delay) return;
	
	    delay = setTimeout(function () {
	      if ($stickyAds.attr('data-rendered') === 'true') {
	        $stickyAds.show();
	        $stickyAds.attr('data-rendered', false);
	        /*if (document.location.href.indexOf("/cultura/") > -1 && 'noticia' === vocento.tracking.comscore.voc_tc) {
	            setTimeout(function () {
	                Voonto.$('.publi-sticky.sticky > .botones.cerrar').click();
	            }, 3000);
	        }*/
	      }
	      delay = false;
	    }, 50);
	  });
	} else {
	  if (vocento.tracking.comscore.voc_tc !== 'portada' && vocento.tracking.comscore.voc_tc !== 'portadilla') {
	    app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(function () {
	      Voonto.$('[data-sticky]').stick_in_parent({
	        offset_top: 20,
	        spacer: false
	      });
	    });
	
	    (0, _stickyKit.initSticky)();
	
	    Voonto.$(window).on('resize', function () {
	      Logger.info('[Sticky] Window Resize');
	      (0, _stickyKit.recalcSticky)();
	    });
	
	    Voonto.$('[data-voc-vam]').on('vam:viewable', function () {
	      Logger.info('[Sticky] Banner', Voonto.$(this), 'viewable');
	      (0, _stickyKit.recalcSticky)();
	    });
	
	    app.on('layout:init-sticky', function () {
	      (0, _stickyKit.initSticky)();
	    });
	
	    app.on('layout:recalc-sticky', function () {
	      (0, _stickyKit.recalcSticky)();
	    });
	
	    document.addEventListener('scroll', nibara.nTools.throttle(200, function () {
	      (0, _stickyKit.recalcSticky)();
	    }));
	  }
	}
	
	/** VocUser **********************************************************************/
	var vocUserPath = app.lookup('vocento.config.nibara').vocUserPath;
	if (vocUserPath === undefined) {
	  throw 'vocUserPath path in config is empty';
	}
	var vocUserVersion = app.lookup('vocento.config.nibara').vocUserVersion;
	if (vocUserVersion === undefined) {
	  throw 'vocuser version is empty';
	}
	Logger.info('Loading vocuser version: ' + vocUserVersion);
	app.load(vocUserPath + '/vocento-vocuser-preloader.js?v=' + vocUserVersion);
	
	/** Comments */
	var commentsPath = app.lookup('vocento.config.nibara').commentsPath;
	Logger.info('Loading comments version: ' + commentsPath);
	if (commentsPath === undefined) {
	  throw 'commentsPath path in config is empty';
	}
	
	app.when('vocuser:gigyaready').then(function (e) {
	  app.load(commentsPath + '/comments.js');
	});
	
	/** Vam **************************************************************************/
	
	if (feature.homeBacktrace && Voonto.$('body').data('seccion') === 'portada' && window.nibara.isBack === true) {
	
	  if (history.state.section === 'main' && typeof history.state.scrollTop !== 'undefined' && history.state.scrollTop > Voonto.$('[data-section="main"]').height()) {
	    _sectionLoadUtils2.default.disableHomeTopAds();
	  }
	  if (history.state.lastSectionView !== 'main') {
	    _sectionLoadUtils2.default.disableHomeTopAds();
	  }
	}
	
	if (window.location.search.indexOf('nDebug_vam=1') > 0) {
	  (0, _vamDebug2.default)(app);
	} else {
	  var vamPath = app.lookup('vocento.config.nibara').vamPath;
	  if (vamPath === undefined) {
	    throw 'nibara vamPath config is empty';
	  }
	  var vamUrl = vamPath + "/vam.js";
	  Logger.info('Loading vam version: ' + vamUrl);
	
	  app.load(vamUrl);
	}
	
	/** Vam empty position autohide ***************************************************/
	Voonto.$('[data-voc-vam]').on('vam:isempty', function () {
	  if ($(this).parent().hasClass('publicidad-portada')) {
	    Logger.info('[VAM] Ad slot is empty, hide position: ' + Voonto.$(this).data('voc-vam-position'));
	    Voonto.$(this).hide();
	    Voonto.$(this).parent().hide();
	  }
	});
	
	Voonto.getInstance().when('vam:apiready').then(function (vamApi) {
	  var adsContainer = [].concat(_toConsumableArray(document.querySelectorAll('[data-voc-vam]')));
	  adsContainer.forEach(function (element) {
	    vamApi.isPositionInactive({ position: element.dataset.vocVamPosition + "-id" }).then(function (inactive) {
	      if (inactive) {
	        Logger.info('[VAM] Ad slot is inactive, hide position: ' + Voonto.$(element).data('voc-vam-position'));
	        Voonto.$(undefined).hide();
	        Voonto.$(undefined).parent().hide();
	      }
	    });
	  });
	});
	
	/** header search widget *********************************************************/
	var $formsBusqueda = Voonto.$(".buscador-cabecera, nav.navegacion form.buscador");
	
	$formsBusqueda.on("submit", function (e) {
	  e.preventDefault();
	  e.stopPropagation();
	
	  Logger.info('Buscador cabecera');
	
	  var str = Voonto.$(this).find('input').val();
	  var location = '/hemeroteca/';
	
	  if (str.length > 0) {
	    str = window.nibara.nTools.kebabCase(str);
	    if (window.location.href.indexOf('lavozdigital.es') > -1) {
	      location += 'noticias/';
	      str += '.html';
	    }
	    location += str;
	  }
	
	  Logger.debug('Buscador action: ', location);
	  window.location.href = location;
	
	  return false;
	});
	
	$formsBusqueda.find('input').on('keypress', function (e) {
	  if (e.which === 13) {
	    var $parentForm = Voonto.$(this).closest('form');
	    Logger.info('Buscador keypress Enter -> trigger submit form.'.$parentForm.attr('class'));
	    $parentForm.trigger('submit');
	  }
	});
	
	/** cookie law (deprecated) ***/
	if (feature.cookieLaw) {
	  var createCookieLaw = function createCookieLaw() {
	    if (document.cookie.indexOf("cookie_20170731") === -1) {
	      var cookieName = 'cookie_20170731';
	      Logger.info('[Cookie Layer] createCookieLaw: ' + cookieName);
	      var cookieDate = new Date();
	      cookieDate.setFullYear(cookieDate.getFullYear() + 1);
	      document.cookie = cookieName + '=visited; expires=' + cookieDate.toGMTString() + ';';
	      Voonto.$('.capa-cookies').fadeOut().hide();
	    }
	  };
	
	  var checkCookieLaw = function checkCookieLaw() {
	    Logger.info('[Cookie Layer] checkCookieLaw');
	    if (document.cookie.indexOf("cookie_20170731") === -1) {
	      var cookieDiv = $('.capa-cookies');
	      cookieDiv.show();
	
	      Voonto.$(window).one('mousewheel', function (e) {
	        Logger.info('[Cookie Layer] create cookie mousewheel');
	        createCookieLaw();
	      });
	
	      Voonto.$(window).one('scroll', function (e) {
	        Logger.info('[Cookie Layer] create cookie scroll');
	        createCookieLaw();
	      });
	
	      Voonto.$(window).one('touchmove', function (e) {
	        Logger.info('[Cookie Layer] create cookie touchmove');
	        createCookieLaw();
	      });
	
	      cookieDiv.click(function () {
	        Logger.info('[Cookie Layer] create cookie click');
	        createCookieLaw();
	      });
	    }
	  };
	
	  Logger.debug("feature cookieLaw active");
	}
	
	/** Push notifications Indigitall ************************************************************/
	document.addEventListener('indigitallReady', function () {
	  var defaultChannels = [];
	  var domainPush = 'push.abc.es';
	  if (document.URL.indexOf('sevilla.abc.es') > -1) {
	    domainPush = 'push-sevilla.abc.es';
	  } else if (document.URL.indexOf('.lavozdigital.es') > -1) {
	    domainPush = 'push.lavozdigital.es';
	  }
	  var url = "https://" + domainPush + "/pushStatusChecker.html?v=1";
	
	  (0, _pushNotificationIndigitall.checkPushStatus)(url, function (response) {
	    Logger.debug(domainPush + ' enabled: ' + response.permission);
	    if (!response.permission) {
	      var oldState = window.Notification.permission;
	      navigator.indigitall.loadIndigitall(function () {
	        var newState = window.Notification.permission;
	        if (newState != oldState && newState == 'granted' && Array.isArray(defaultChannels) && defaultChannels.length > 0) {
	          (0, _pushNotificationIndigitall.subscribeToChannels)(defaultChannels);
	        }
	      });
	    } else {
	      navigator.indigitall.loadIndigitall(function () {
	        if (Array.isArray(response.channels) && response.channels.length > 0) {
	          (0, _pushNotificationIndigitall.subscribeToChannels)(response.channels);
	        } else if (Array.isArray(defaultChannels) && defaultChannels.length > 0) {
	          (0, _pushNotificationIndigitall.subscribeToChannels)(defaultChannels);
	        }
	      });
	    }
	  });
	});
	
	app.load('/indigitall/indigitall.min.js?v=20190218');
	
	/** create cookie function *******************************************************/
	function createCookie(src) {
	  var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  Logger.info('[Breaking News] Creo una cookie para un tiempo de vida de 1 hora.');
	  // Creo una cookie para un tiempo de vida de 1 hora.
	  var date = new Date();
	  var minutes = 60;
	  date.setTime(date.getTime() + minutes * 60 * 1000);
	
	  var cookieParameters = { path: '/', expires: date };
	  Cookies(src, content, cookieParameters);
	}
	
	function compruebaCookie() {
	  Logger.info('[Breaking News] compruebaCookie');
	  var src = 'BreakingNews-ABC';
	  Logger.info('[Breaking News] src: ' + src);
	  return !(Cookies(src) === null || Cookies(src) === "" || Cookies(src) === "null" || typeof Cookies(src) === 'undefined');
	}
	
	/** sticky breaking-news|social|ads *********************************************************/
	if (feature.breakingNews && (Voonto.is.mobile() || Voonto.is.tablet())) {
	
	  var $urgente = Voonto.$('.urgente-teinteresa');
	  if ($urgente.length > 0) {
	    var $cerrarUrgente = $urgente.find('.cerrar');
	    var type = $cerrarUrgente.data('type');
	    if (type === 'urgente') {
	      if (compruebaCookie()) {
	        Logger.info('[Breaking News] urgente hide. Existe cookie');
	        $urgente.hide();
	      } else {
	        Logger.info('[Breaking News] urgente show. No existe cookie');
	        $urgente.show();
	      }
	    } else {
	      Logger.info('[Breaking News] urgente show. Existe urgente multiple');
	      $urgente.show();
	    }
	
	    $cerrarUrgente.click(function () {
	      $urgente.hide();
	      Voonto.SocialToolbar.enable();
	
	      var type = $cerrarUrgente.data('type');
	      if (type === 'te-interesa') {
	        return false;
	      }
	
	      var src = 'BreakingNews-ABC';
	      var content = 'Breaking News - ABC';
	      createCookie(src, content);
	    });
	  }
	
	  Voonto.$('.noticia').click(function () {
	    Logger.info('[Breaking News] click noticia');
	    var type = Voonto.$(this).data('type');
	    if (type === 'urgente') {
	      var src = 'BreakingNews-ABC';
	      var content = 'Breaking News - ABC';
	      createCookie(src, content);
	    }
	
	    Logger.info('[Breaking News] type: ', type);
	
	    var href = Voonto.$(this).data('href');
	    if (typeof href !== 'undefined') {
	      Logger.info('[Breaking News] href: ', href);
	      window.location.href = href;
	    }
	  });
	}
	
	/** sticky teInteresa|ads ***************************************************/
	if (feature.teInteresa && (Voonto.is.mobile() || Voonto.is.tablet())) {
	  Logger.debug("feature teInteresa active");
	
	  $stickyAds.find('[data-voc-vam]').on('vam:isempty', function () {
	    Logger.info('[data-voc-vam][Breaking News] position megabanner_sticky is empty');
	    var $urgente = Voonto.$('.urgente-teinteresa');
	    var showTeInteresa = true;
	    if ($urgente.length > 0) {
	      var _$cerrarUrgente = $urgente.find('.cerrar');
	      var _type = _$cerrarUrgente.data('type');
	      if (_type === 'urgente') {
	        if (compruebaCookie()) {
	          Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
	        } else {
	          Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
	          showTeInteresa = false;
	        }
	      } else {
	        Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
	        showTeInteresa = false;
	      }
	    }
	
	    if (!showTeInteresa) {
	      Logger.info('BreakingNews ad slot is empty but exist urgente');
	      $stickyAds.hide();
	    } else {
	      if (Voonto.$('body').data('seccion') !== 'portada') {
	        Logger.info('BreakingNews ad slot is empty');
	        $stickyAds.hide();
	        var teinteresa = new _teInteresa2.default();
	        teinteresa.load(Voonto.$('#breaking-news-container'));
	      }
	    }
	  });
	
	  $stickyAds.find('[data-voc-vam]').on('vam:inactive', function () {
	    Logger.info('[data-voc-vam][Breaking News] position megabanner_sticky is inactive');
	    var $urgente = Voonto.$('.urgente-teinteresa');
	    var showTeInteresa = true;
	    if ($urgente.length > 0) {
	      var _$cerrarUrgente2 = $urgente.find('.cerrar');
	      var _type2 = _$cerrarUrgente2.data('type');
	      if (_type2 === 'urgente') {
	        if (compruebaCookie()) {
	          Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
	        } else {
	          Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
	          showTeInteresa = false;
	        }
	      } else {
	        Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
	        showTeInteresa = false;
	      }
	    }
	
	    if (!showTeInteresa) {
	      Logger.info('BreakingNews ad slot is inactive but exist urgente');
	      $stickyAds.hide();
	    } else {
	      if (Voonto.$('body').data('seccion') !== 'portada') {
	        Logger.info('BreakingNews ad slot is inactive');
	        $stickyAds.hide();
	        var teinteresa = new _teInteresa2.default();
	        teinteresa.load(Voonto.$('#breaking-news-container'));
	      }
	    }
	  });
	
	  $stickyAds.find('[data-voc-vam]').on('vam:slotrendered', function () {
	    var $urgente = Voonto.$('.urgente-teinteresa');
	    var showTeInteresa = true;
	    if ($urgente.length > 0) {
	      var _$cerrarUrgente3 = $urgente.find('.cerrar');
	      var _type3 = _$cerrarUrgente3.data('type');
	      if (_type3 === 'urgente') {
	        if (compruebaCookie()) {
	          Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
	        } else {
	          Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
	          showTeInteresa = false;
	        }
	      } else {
	        Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
	        showTeInteresa = false;
	      }
	    }
	
	    if (!showTeInteresa) {
	      Logger.info('[data-voc-vam][Breaking News] ad slot is active but exist urgente');
	      $stickyAds.hide();
	    } else {
	      Logger.info('[data-voc-vam][Breaking News] ad slot is active');
	      $stickyAds.attr('data-rendered', true);
	    }
	  });
	
	  /**
	   * show Ads sticky when detect scroll
	   * @type {boolean}
	   */
	  var _delay = false;
	  Voonto.$(window).on("scroll", function () {
	    if (_delay) return;
	
	    _delay = setTimeout(function () {
	      if ($stickyAds.attr('data-rendered') === 'true') {
	        $stickyAds.show();
	        $stickyAds.attr('data-rendered', false);
	        if (document.location.href.indexOf("/cultura/") > -1 && 'noticia' === vocento.tracking.comscore.voc_tc) {
	          setTimeout(function () {
	            Voonto.$('.publi-sticky.sticky > .botones.cerrar').click();
	          }, 3000);
	        }
	      }
	      _delay = false;
	    }, 50);
	  });
	
	  $stickyAds.on('click', function () {
	    Voonto.$(this).hide();
	  });
	}
	
	// Comportamiento para cerrar el menu de compartir cuando se hace scroll
	if (feature.shareLayer) {
	  Logger.debug("feature shareLayer active");
	  var inputShareLayer = Voonto.$('input#capa_compartir'),
	      labelShareLayer = Voonto.$('label[for="capa_compartir"]'),
	      inputFixedLayer = Voonto.$('input#capa_compartir_fija'),
	      labelFixedLayer = Voonto.$('label[for="capa_compartir_fija"]'),
	      containerShareLayer = Voonto.$('aside.herramientas:not(.fija) .mas-compartir'),
	      containerShareFixedLayer = Voonto.$('aside.herramientas.fija .mas-compartir');
	
	  var closeShareLayerHandler = function closeShareLayerHandler() {
	    Logger.info('[CloseShareLayerHandler] scrolled');
	
	    if (inputShareLayer.prop('checked') === true) {
	      inputShareLayer.prop('checked', false);
	      Logger.info('[CloseShareLayerHandler] ShareLayer abierta, cerrando..');
	    }
	
	    Voonto.$(window).unbind('scroll', undefined);
	    Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
	  };
	
	  var closeFixedShareLayerHandler = function closeFixedShareLayerHandler() {
	    Logger.info('[CloseFixedShareLayerHandler] scrolled');
	
	    if (inputFixedLayer.prop('checked') === true) {
	      inputFixedLayer.prop('checked', false);
	      Logger.info('[CloseShareLayerHandler] ShareFixedLayer abierta, cerrando..');
	    }
	
	    Voonto.$(window).unbind('scroll', undefined);
	    Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
	  };
	
	  var closeClickDocumentShareLayerHandler = function closeClickDocumentShareLayerHandler(e) {
	    Logger.info('[CloseShareLayerHandler] document onclick');
	
	    if (inputShareLayer.prop('checked') === true) {
	      // esta abierto el menu compartir
	      if (Voonto.$.contains(containerShareLayer.get(0), e.target) === false && Voonto.$.contains(labelShareLayer.get(0), e.target) === false) {
	        inputShareLayer.prop('checked', false);
	        Voonto.$(document).unbind('click', undefined);
	        Voonto.$(window).unbind('scroll', closeShareLayerHandler);
	        Logger.info('[CloseShareLayerHandler] ShareLayer abierta, cerrando..');
	      }
	    }
	
	    if (inputFixedLayer.prop('checked') === true) {
	      // esta abierto el menu compartir de la barra fija
	      if (Voonto.$.contains(containerShareFixedLayer.get(0), e.target) === false && Voonto.$.contains(labelFixedLayer.get(0), e.target) === false) {
	        inputFixedLayer.prop('checked', false);
	        Voonto.$(document).unbind('click', undefined);
	        Voonto.$(window).unbind('scroll', closeFixedShareLayerHandler);
	        Logger.info('[CloseShareLayerHandler] ShareFixedLayer abierta, cerrando..');
	      }
	    }
	  };
	
	  inputShareLayer.on('change', function () {
	    var $this = Voonto.$(this);
	    Logger.info('[CloseShareLayerHandler] input change');
	    if ($this.prop('checked') === true) {
	      Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler).on('click', closeClickDocumentShareLayerHandler);
	    } else {
	      Voonto.$(window).unbind('scroll', closeShareLayerHandler);
	      Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
	    }
	  });
	
	  inputFixedLayer.on('change', function () {
	    var $this = Voonto.$(this);
	    Logger.info('[CloseFixedShareLayerHandler] input change');
	    if ($this.prop('checked') === true) {
	      Voonto.$(window).one('scroll', closeFixedShareLayerHandler);
	      Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler).on('click', closeClickDocumentShareLayerHandler);
	    } else {
	      Voonto.$(window).unbind('scroll', closeFixedShareLayerHandler);
	      Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
	    }
	  });
	}
	
	/*************** Notificaciones MiABC y Popup datos adicionales *******************/
	app.when('vocuser:ready').then(function (gigyaUX) {
	  Logger.debug('[vocuser-ready] gigyaUX', gigyaUX);
	  var userType = gigyaUX.getUserType();
	  if (userType !== 'anonimo') {
	    Logger.debug('[vocuser-ready] usuario logado', gigyaUX);
	    (0, _vocuserNotifications.notificationsLoad)();
	    (0, _additionaldataScript.checkInterest)();
	  }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.getTimeoutPopup = getTimeoutPopup;
	exports.parseUrl = parseUrl;
	exports.createCSData = createCSData;
	exports.getInitialText = getInitialText;
	exports.createPopupCookie = createPopupCookie;
	exports.getUserDataText = getUserDataText;
	exports.checkUserData = checkUserData;
	exports.updateAdditionalData = updateAdditionalData;
	exports.isValidDate = isValidDate;
	exports.checkUserInterests = checkUserInterests;
	exports.handleCheckedInterestsClick = handleCheckedInterestsClick;
	exports.getUserInterests = getUserInterests;
	exports.updateUserInterests = updateUserInterests;
	exports.checkInterest = checkInterest;
	exports.updatedUserInfo = updatedUserInfo;
	exports.actionCustomService = actionCustomService;
	//TIMEOUTS EN MILISEGUNDOS
	var POPUP_TIMEOUT_STARRED = 10000;
	var POPUP_TIMEOUT_FOLLOWING = 5000;
	var POPUP_TIMEOUT_OPINION = 10000;
	var POPUP_TIMEOUT_CREATE_COMMENT = 5000;
	var POPUP_TIMEOUT_LIKE_COMMENT = 5000;
	var POPUP_TIMEOUT_CONTEST = 10000;
	var POPUP_TIMEOUT_EVENT = 10000;
	var POPUP_TIMEOUT_REGISTER = 15000; //DEF
	//const POPUP_TIMEOUT_REGISTER = 60000;
	var POPUP_TIMEOUT_LOGIN = 60000; //DEF
	//const POPUP_TIMEOUT_LOGIN = 3000;
	
	//const EXPIRE_COOKIE_POPUP_TIME = 180000; //3 MINUTOS
	var EXPIRE_COOKIE_POPUP_TIME = 2592000000; //30 DIAS (DEF)
	
	var app = Voonto.getInstance();
	var vocUserNotificationsPath = app.lookup('vocento.config.nibara').vocUserNotifications;
	
	var savedData = false;
	
	function getTimeoutPopup($btn) {
	    switch ($btn) {
	        case 'starred':
	            return POPUP_TIMEOUT_STARRED;
	            break;
	        case 'following':
	            return POPUP_TIMEOUT_FOLLOWING;
	            break;
	        case 'event':
	            return POPUP_TIMEOUT_EVENT;
	            break;
	        case 'contest':
	            return POPUP_TIMEOUT_CONTEST;
	            break;
	        case 'new-comment':
	            return POPUP_TIMEOUT_CREATE_COMMENT;
	            break;
	        case 'like-comment':
	            return POPUP_TIMEOUT_LIKE_COMMENT;
	            break;
	        case 'opinion':
	            return POPUP_TIMEOUT_OPINION;
	            break;
	        case 'register':
	            return POPUP_TIMEOUT_REGISTER;
	            break;
	        default:
	            return POPUP_TIMEOUT_LOGIN;
	            break;
	    }
	}
	
	function parseUrl(url) {
	    var parser = document.createElement('a');
	    parser.href = url;
	    return {
	        protocol: parser.protocol,
	        host: parser.host,
	        hostname: parser.hostname,
	        port: parser.port,
	        pathname: parser.pathname,
	        hash: parser.hash,
	        search: parser.search,
	        origin: parser.origin
	    };
	}
	
	function createCSData($elm) {
	    Logger.debug('[post-script] createCSData - $elm >> ' + $elm.data('btn'));
	    var serviceId = '';
	    var serviceReference = '';
	    var url = parseUrl(document.location.href);
	    var pathname = url.pathname;
	    var section = '';
	    var host = location.host;
	    // (host == 'abcblogsv2.abc.es' || host == 'pre-abcblogsv2.abc.es')
	    if (pathname == '' || pathname == '/') {
	        section = "home";
	    } else if (host.match(/abcblogsv2/gi)) {
	        section = 'blogs';
	    } else {
	        var res = pathname.split("/");
	        section = res[1];
	    }
	    if ($elm.data('btn') === 'starred') {
	        serviceId = '190';
	        serviceReference = section;
	    } else if ($elm.data('btn') === 'following') {
	        serviceId = '195';
	        if (section === 'play') {
	            serviceReference = $elm.parent().find('.nombre a').attr('title');
	        } else {
	            serviceReference = $elm.parent().find('.autor').attr('title');
	        }
	        Logger.debug('[post-script] createCSData - serviceReference >> ' + serviceReference);
	        if ('undefined' === typeof serviceReference) {
	            var vocUserNotificationsPath = app.lookup('vocento.config.nibara').vocUserNotifications;
	            Logger.debug('[post-script] createCSData - vocUserNotificationsPath >> ' + vocUserNotificationsPath);
	            Logger.debug('[post-script] createCSData - section >> ' + section);
	            if (vocUserNotificationsPath !== undefined) {
	                serviceReference = section;
	            }
	        }
	        Logger.debug('[post-script] createCSData - serviceReference >> ' + serviceReference);
	        serviceReference = serviceReference.normalize("NFKD").replace(/[\u0300-\u036F]/g, "").replace(/ /g, "_");
	    }
	    return {
	        serviceId: serviceId,
	        serviceReference: serviceReference
	    };
	}
	
	function getInitialText($btn) {
	    var initialText = "Queremos conocerte";
	    switch ($btn) {
	        case 'starred':
	            initialText = 'Has guardado el artículo correctamente, ahora queremos conocerte mejor';
	            break;
	        case 'following':
	            initialText = 'Nos complace saber que sigues a nuestros autores, ahora queremos conocerte mejor';
	            break;
	        case 'event':
	            initialText = 'Ya estás apuntado para el evento, ahora queremos conocerte mejor';
	            break;
	        case 'contest':
	            initialText = 'Ya estás participando en el concurso, ahora queremos conocerte mejor';
	            break;
	        case 'new-comment':
	            initialText = 'Tu comentario se ha publicado correctamente, ahora nos gustaría conocerte mejor';
	            break;
	        case 'like-comment':
	            initialText = 'Tu valoración del comentario se ha guardado correctamente, ahora nos gustaría conocerte mejor';
	            break;
	        case 'opinion':
	            initialText = 'Queremos conocerte';
	            break;
	    }
	    $('.popup_info').find('.textevent').text(initialText);
	}
	
	function createPopupCookie($elm) {
	    var expires = new Date();
	    expires.setTime(expires.getTime() + EXPIRE_COOKIE_POPUP_TIME);
	    var cookie = "check_interests=" + $elm.data('btn') + ";expires=" + expires.toUTCString() + ";path=/";
	    Logger.debug("[cookie popup creada]");
	    return document.cookie = cookie;
	}
	
	function getUserDataText($arrayNames) {
	    var fieldText = '';
	    var nameAux = '';
	    for (var i = 0; i < $arrayNames.length; i++) {
	        nameAux = $arrayNames[i] == 'edad' ? 'fecha de nacimiento' : $arrayNames[i];
	        if (i == 0) {
	            fieldText = nameAux;
	        } else if (i == $arrayNames.length - 1) {
	            fieldText = fieldText + ' y ' + nameAux;
	        } else {
	            fieldText = fieldText + ', ' + nameAux;
	        }
	    }
	    $('.popup_user_data').find('.fieldstext').text('Por favor ¿Nos puedes facilitar tu ' + fieldText + '?');
	}
	
	function checkUserData($elm, baseurl) {
	
	    var btn = $elm.data('btn');
	
	    var fields = {};
	
	    $('.popup_additional_data').find('select').each(function () {
	        if (!fields.hasOwnProperty($(this).attr('name').split('.')[0])) {
	            fields[$(this).attr('name').split('.')[0]] = [];
	        }
	        fields[$(this).attr('name').split('.')[0]].push($(this).attr('name').split('.')[1]);
	    });
	
	    //   Logger.debug('[listado fields]', fields);
	
	    Voonto.$.ajax({
	        url: baseurl + 'fields/show',
	        xhrFields: {
	            withCredentials: true
	        },
	        timeout: 10000
	    }).fail(function (jqXHR, textStatus, errorThrown) {
	        Logger.error('show fields module: retrieve ' + btn + ' error ', textStatus);
	        return null;
	    }).done(function (response) {
	
	        if (response && 'undefined' !== typeof response.code && response.code === 200) {
	            var user = response.user;
	            var countShow = 0;
	            $('.popup_user_data').hide();
	            $('.popup_user_data').removeClass('next_popup');
	            $('.popup_user_data div').hide();
	            $('.popup_user_data').find('div').each(function () {
	                $(this).removeClass('next_field');
	            });
	            $('.popup_user_data').find('select').each(function () {
	                $(this).attr('required', false);
	            });
	            $('.popup_user_interests').hide();
	            $('.popup_user_interests').removeClass('next_popup');
	            var arrayNames = [];
	            Object.keys(fields).forEach(function (key) {
	                var field = fields[key];
	                Object.keys(field).forEach(function (i) {
	                    if (key == 'profile' && (field[i] == 'birthDay' || field[i] == 'birthMonth' || field[i] == 'birthYear')) {
	                        var currentDate = new Date();
	                        if (parseInt(user[key]['birthYear']) > parseInt(currentDate.getFullYear()) - 13 || user[key]['birthDay'] === undefined || user[key]['birthMonth'] === undefined || user[key]['birthYear'] === undefined) {
	                            $('.popup_user_data .popup_' + field[i]).addClass('next_field');
	                            $('.popup_user_data .popup_' + field[i]).find('select').each(function () {
	                                if (user[key]['birthDay'] !== undefined) {
	                                    $('.popup_birthDay').find('.birthday').val(user[key]['birthDay'].length < 2 ? "0" + user[key]['birthDay'] : user[key]['birthDay']).change();
	                                }
	                                if (user[key]['birthMonth'] !== undefined) {
	                                    $('.popup_birthDay').find('.birthmonth').val(user[key]['birthMonth'].length < 2 ? "0" + user[key]['birthMonth'] : user[key]['birthMonth']).change();
	                                }
	                                if (parseInt(user[key]['birthYear']) <= parseInt(currentDate.getFullYear()) - 13 && user[key]['birthYear'] !== undefined) {
	                                    $('.popup_birthDay').find('.birthyear').val(user[key]['birthYear']).change();
	                                }
	                            });
	                            countShow = countShow + 1;
	                            if (field[i] == 'birthDay') {
	                                var nameField = $('.popup_user_data .popup_' + field[i]).find('label').attr('class').split('_')[1];
	                                if (arrayNames.indexOf(nameField) == -1) {
	                                    arrayNames.push(nameField);
	                                }
	                            }
	                        }
	                    } else {
	                        if (user[key][field[i]] === undefined || user[key][field[i]] === 'u') {
	                            $('.popup_user_data .popup_' + field[i]).addClass('next_field');
	                            countShow = countShow + 1;
	                            arrayNames.push($('.popup_user_data .popup_' + field[i]).find('label').attr('class').split('_')[1]);
	                        }
	                    }
	                });
	            });
	
	            var username = user['profile']['firstName'] === undefined ? user['profile']['nickname'] : user['profile']['firstName'];
	            $('.popup_info .username').text(username);
	            getInitialText(btn);
	            getUserDataText(arrayNames);
	            $('.popup_info').addClass('current_popup');
	            $('.popup_info').show();
	            if (countShow > 0) {
	                $('.popup_additional_data').find('.popup_user_data').addClass('next_popup');
	            } else {
	                $('.popup_additional_data').find('.popup_user_interests').addClass('next_popup');
	            }
	            $('.popup_additional_data').show();
	        }
	    });
	}
	
	function updateAdditionalData(baseurl) {
	
	    var newfields = {};
	
	    $('.popup_additional_data').find('.next_field select').each(function () {
	        if ($(this).val() != '') {
	            if (!newfields.hasOwnProperty($(this).attr('name').split('.')[0])) {
	                newfields[$(this).attr('name').split('.')[0]] = {};
	            }
	            newfields[$(this).attr('name').split('.')[0]][$(this).attr('name').split('.')[1]] = $(this).val();
	        }
	    });
	
	    $('.popup_additional_data').find('.next_field select.birthday').attr('required', false);
	    if ($('.popup_additional_data').find('select.birthday').hasClass('next_field')) {
	        $('.popup_additional_data').find('.next_field select.birthday')[0].setCustomValidity('');
	    }
	    $('.popup_additional_data').find('.next_field select.birthmonth').attr('required', false);
	    $('.popup_additional_data').find('.next_field select.birthyear').attr('required', false);
	
	    if ($('.popup_additional_data').find('.next_field').hasClass('popup_birthDay') && ($('.popup_additional_data').find('.next_field select.birthday').val() != '' || $('.popup_additional_data').find('.next_field select.birthmonth').val() != '' || $('.popup_additional_data').find('.next_field select.birthyear').val() != '')) {
	        if ($('.popup_additional_data').find('.next_field select.birthday').val() == '' || $('.popup_additional_data').find('.next_field select.birthmonth').val() == '' || $('.popup_additional_data').find('.next_field select.birthyear').val() == '') {
	            $('.popup_additional_data').find('.next_field select.birthday').attr('required', 'required');
	            $('.popup_additional_data').find('.next_field select.birthmonth').attr('required', 'required');
	            $('.popup_additional_data').find('.next_field select.birthyear').attr('required', 'required');
	            $(".popup_user_data #form_fields")[0].reportValidity();
	            return;
	        } else {
	            var date = $('.popup_additional_data').find('.next_field select.birthday').val() + '-' + $('.popup_additional_data').find('.next_field select.birthmonth').val() + '-' + $('.popup_additional_data').find('.next_field select.birthyear').val();
	            if (!isValidDate(date)) {
	                $('.popup_additional_data').find('.next_field select.birthday')[0].setCustomValidity("Revisa los elementos de la fecha");
	                $(".popup_user_data #form_fields")[0].reportValidity();
	                return;
	            }
	        }
	    }
	
	    if (Object.keys(newfields).length > 0) {
	
	        var data = { 'fields': newfields };
	
	        $.ajax({
	            type: 'post',
	            url: baseurl + 'fields/update',
	            data: data,
	            dataType: 'json',
	            xhrFields: {
	                withCredentials: true
	            },
	            timeout: 10000
	        }).fail(function (jqXHR, textStatus, errorThrown) {
	            Logger.error('additionaldata module update fields error: ', textStatus);
	        }).done(function (response) {
	            savedData = true;
	            getUserInterests();
	            Logger.debug('[actualizar datos]', response);
	        });
	    } else {
	        getUserInterests();
	    }
	}
	
	function isValidDate(s) {
	    // format D(D)/M(M)/(YY)YY
	    var dateFormat = /^\d{1,4}[\.|\/|-]\d{1,2}[\.|\/|-]\d{1,4}$/;
	
	    if (dateFormat.test(s)) {
	        // remove any leading zeros from date values
	        s = s.replace(/0*(\d*)/gi, "$1");
	        var dateArray = s.split(/[\.|\/|-]/);
	
	        // correct month value
	        dateArray[1] = dateArray[1] - 1;
	
	        // correct year value
	        if (dateArray[2].length < 4) {
	            // correct year value
	            dateArray[2] = parseInt(dateArray[2]) < 50 ? 2000 + parseInt(dateArray[2]) : 1900 + parseInt(dateArray[2]);
	        }
	
	        var testDate = new Date(dateArray[2], dateArray[1], dateArray[0]);
	        if (testDate.getDate() != dateArray[0] || testDate.getMonth() != dateArray[1] || testDate.getFullYear() != dateArray[2]) {
	            return false;
	        } else {
	            return true;
	        }
	    } else {
	        return false;
	    }
	}
	
	function checkUserInterests($elm, baseurl) {
	
	    Logger.info('additionaldata module interests');
	
	    var btn = $elm.data('btn');
	
	    Voonto.$.ajax({
	        url: baseurl + 'interests/check',
	        xhrFields: {
	            withCredentials: true
	        },
	        timeout: 10000
	    }).fail(function (jqXHR, textStatus, errorThrown) {
	        Logger.error('show interests module: retrieve ' + btn + ' error ', textStatus);
	        return null;
	    }).done(function (response) {
	        if (response && 'undefined' !== typeof response.code && response.code === 200) {
	            if (!response.hasinterests) {
	                if (response.interestslist.length > 0) {
	                    $('.popup_user_interests #form_interests').html('');
	                    for (var i = 0; i < response.interestslist.length; i++) {
	                        var elem = response.interestslist[i];
	                        var code = elem['code'];
	                        $('.popup_user_interests #form_interests').append('<input id="' + code + '" type="checkbox" class="nibara-element" data-nibara-module="additionaldata" data-btn="checkinterests">');
	                        if (code.substr(0, code.indexOf('.000')) + '.000' == code) {
	                            $('.popup_user_interests #form_interests').append('<label for="' + code + '">' + elem['category'] + '</label>');
	                        } else if (elem.name != '') {
	                            $('.popup_user_interests #form_interests').append('<label for="' + code + '">' + elem['name'] + '</label>');
	                        } else {
	                            $('.popup_user_interests #form_interests').append('<label for="' + code + '">' + elem['subcategory'] + '</label>');
	                        }
	                    }
	                }
	                $('.popup_user_interests #form_interests').find('input[type="checkbox"]').on('click', handleCheckedInterestsClick);
	                createPopupCookie($elm);
	                if (document.cookie.match(/^(.*;)?\s*check_interests\s*=\s*[^;]+(.*)?$/)) {
	                    checkUserData($elm, baseurl);
	                }
	            }
	        }
	    });
	}
	
	function handleCheckedInterestsClick() {
	    var attr = $(this).attr('checked');
	    if ((typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) !== ( true ? 'undefined' : _typeof(undefined)) && attr !== false) {
	        $(this).removeAttr('checked');
	    } else {
	        $(this).attr('checked', 'checked');
	    }
	}
	
	function getUserInterests() {
	    var currentcontainer = Voonto.$('.popup_user_interests');
	    var oldnextcontainer = Voonto.$('.popup_additional_data').find('.current_popup');
	    oldnextcontainer.hide();
	    oldnextcontainer.removeClass('current_popup');
	    currentcontainer.addClass('current_popup');
	    currentcontainer.show();
	}
	
	function updateUserInterests(baseurl) {
	    Logger.info('additionaldata module interests update');
	
	    var interests = [];
	
	    $('.popup_additional_data .popup_user_interests').find('input[type="checkbox"]').each(function () {
	        var attr = $(this).attr('checked');
	        if ((typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) !== ( true ? 'undefined' : _typeof(undefined)) && attr !== false) {
	            var interest = {};
	            interest['ID'] = $(this).attr('id');
	            interest['type'] = 'manual';
	            interest['status'] = (typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) !== ( true ? 'undefined' : _typeof(undefined)) && attr !== false ? true : false;
	            interests.push(interest);
	        }
	    });
	
	    // Logger.debug('interests checked: ', interests);
	
	    if (interests.length > 0) {
	        var data = { 'interests': interests };
	
	        $.ajax({
	            type: 'post',
	            url: baseurl + 'interests/update',
	            data: data,
	            dataType: 'json',
	            xhrFields: {
	                withCredentials: true
	            },
	            timeout: 10000
	        }).fail(function (jqXHR, textStatus, errorThrown) {
	            Logger.error('additionaldata module update interests error: ', textStatus);
	            var currentContainer = $('.popup_user_interests');
	            currentContainer.hide();
	            currentContainer.removeClass('current_popup');
	            $('.popup_result').addClass('current_popup');
	            $('.popup_result p.p1').html('<strong>¡Ha ocurrido un error!</strong>');
	            $('.popup_result p.p2').text('Por favor, intentalo más tarde');
	            $('.popup_result p.p2').show();
	            $('.popup_result').show();
	        }).done(function (response) {
	            Logger.debug('additionaldata module update', response);
	            if (response && 'undefined' !== typeof response.code && response.code === 200) {
	                Logger.debug('additionaldata module update ok', response);
	            }
	            var currentContainer = $('.popup_user_interests');
	            currentContainer.hide();
	            currentContainer.removeClass('current_popup');
	            $('.popup_result').addClass('current_popup');
	            $('.popup_result p.p1').html('<strong>¡Intereses guardados con éxito!</strong>');
	            $('.popup_result p.p2').text('A partir de ahora, en ABC.es encontrarás información más personalizada según tus preferencias');
	            $('.popup_result p.p2').show();
	            $('.popup_result').show();
	        });
	    } else {
	        var currentContainer = $('.popup_user_interests');
	        currentContainer.hide();
	        currentContainer.removeClass('current_popup');
	        $('.popup_result').addClass('current_popup');
	        if (savedData) {
	            $('.popup_result p.p1').html('<strong>¡Perfil actualizado con éxito!</strong>');
	            $('.popup_result p.p2').text('Podrás seguir completando la información de tu perfil e indicando tus intereses favoritos más adelante en tu Área de Usuario en ABC.es');
	            $('.popup_result p.p2').show();
	        } else {
	            $('.popup_result p.p1').text('Podrás seguir completando la información de tu perfil e indicando tus intereses favoritos más adelante en tu Área de Usuario en ABC.es');
	            $('.popup_result p.p2').text('');
	            $('.popup_result p.p2').hide();
	        }
	        $('.popup_result').show();
	    }
	}
	
	function checkInterest() {
	    Logger.debug('check interest request');
	    var urlReferer = document.referrer;
	    var baseurl = '/ajax/v2/api/v1/';
	    if (vocUserNotificationsPath !== undefined) {
	        baseurl = vocUserNotificationsPath + baseurl;
	    }
	    Logger.debug('[post-script] baseurl: ' + baseurl);
	
	    var timeoutPopupAddData = 0;
	    if (urlReferer.includes("registro/validacion-mail.html")) {
	        var originRegister = window.location.href;
	        var originText = 'register';
	        if (originRegister.includes("/opinion/") && originRegister.includes(".html")) {
	            originText = 'opinion';
	        }
	        timeoutPopupAddData = getTimeoutPopup(originText);
	        setTimeout(function () {
	            if (!document.cookie.match(/^(.*;)?\s*check_interests\s*=\s*[^;]+(.*)?$/)) {
	                var $elm = $('.gigya-registration-link').attr('data-btn', originText);
	                Logger.debug('[additionaldata_popup desde registro]');
	                checkUserInterests($elm, baseurl);
	            }
	        }, timeoutPopupAddData);
	    } else {
	        var originLogin = window.location.href;
	        Logger.debug('[post-script] Origin login: ' + originLogin);
	        if (!originLogin.includes("/micuenta/")) {
	            timeoutPopupAddData = getTimeoutPopup('login');
	            setTimeout(function () {
	                if (!document.cookie.match(/^(.*;)?\s*check_interests\s*=\s*[^;]+(.*)?$/)) {
	                    var $elm = $('.gigya-login-link').attr('data-btn', 'login');
	                    Logger.debug('[additionaldata_popup desde login]');
	                    checkUserInterests($elm, baseurl);
	                }
	            }, timeoutPopupAddData);
	        }
	    }
	}
	
	function updatedUserInfo() {
	    return savedData;
	}
	
	/* Podemos Cargar esta en el scrip gigya.js y hacer un export/import */
	function actionCustomService(action, event, id, section) {
	    var app = Voonto.getInstance();
	    app.when('vocuser:ready').then(function (gigyaUX) {
	        if (typeof gigyaUX !== 'undefined') {
	            if ('update' === action) {
	                gigyaUX.updateCustomerServiceInCookieVocUser(id, section);
	                Logger.debug('[actionCS] CS Update id: ' + id + ', seccion: ' + section);
	                if ('login' === event) {
	                    gigyaUX.showLogin();
	                } else if ('registro' === event) {
	                    gigyaUX.showRegistration();
	                }
	            } else if ('send' === action) {
	                gigyaUX.sendCustomerService(id, section).done(function () {
	                    Logger.debug('[actionCS] CS enviado id: ' + id + ', seccion: ' + section);
	                });
	            }
	        }
	    });
	}

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* globals vocento, noticiaid */
	var app = Voonto.getInstance();
	
	var TeInteresa = function () {
		function TeInteresa(form) {
			_classCallCheck(this, TeInteresa);
	
			this.libPath = app.lookup('vocento.config.nibara').libPath;
			if (this.libPath === undefined) {
				throw 'nibara libPath config is empty';
			}
			this.isMobile = Voonto.is.mobile();
			this.isTablet = Voonto.is.tablet();
		}
	
		_createClass(TeInteresa, [{
			key: 'load',
			value: function load($container) {
				var _this = this;
	
				var comscore = app.lookup('vocento.tracking.comscore');
				var tc = comscore.voc_tcnew ? comscore.voc_tc : null;
				var se = comscore.voc_se;
				if (typeof noticiaid === 'undefined' || !noticiaid || !tc || !se) {
					Logger.error('No se puede cargar te-interesa');
					return false;
				}
	
				var url = "/ajax/v2/te-interesa.html?recid=" + noticiaid + "&voc_tc=" + tc + "&voc_se=" + se;
				Voonto.$.ajax({
					"type": "get",
					"url": url,
					"timeout": 20000
				}).fail(function () {
					Logger.error('No se puede cargar te-interesa');
					_this.mobileShowToolbar();
				}).done(function (html) {
					if (html) {
						_this.mobileHideToolbar();
	
						$container.html(html);
						_this.swiper($container.find('.swiper-container'));
	
						_this.mobileEvents($container);
					} else {
						_this.mobileShowToolbar();
					}
				});
			}
		}, {
			key: 'mobileShowToolbar',
			value: function mobileShowToolbar() {
				if (this.isMobile && Voonto.SocialToolbar) {
					Voonto.SocialToolbar.enable();
				}
			}
		}, {
			key: 'mobileHideToolbar',
			value: function mobileHideToolbar() {
				if (this.isMobile && Voonto.SocialToolbar) {
					Voonto.SocialToolbar.disable();
				}
			}
		}, {
			key: 'mobileEvents',
			value: function mobileEvents($container) {
				var _this2 = this;
	
				if (this.isMobile) {
					this.mobileHideToolbar();
					$container.find('.cerrar').click(function () {
						$container.hide();
						_this2.mobileShowToolbar();
					});
	
					Voonto.$('.noticia').click(function () {
						Logger.info('[Breaking News] click Te-Interesa');
						var type = Voonto.$(this).data('type');
	
						Logger.info('[Breaking News] type: ', type);
						Logger.info('[Breaking News] href: ', Voonto.$(this).data('href'));
	
						window.location.href = Voonto.$(this).data('href');
					});
				}
			}
		}, {
			key: 'swiper',
			value: function swiper($elm) {
				var _this3 = this;
	
				Logger.info('Te-Interesa: Cargado JQuery-UI');
				$elm.find('.swiper-prev-row-bn').css('zIndex', 99);
				$elm.find('.swiper-next-row-bn').css('zIndex', 99);
				$elm.find('.swiper-wrapper').attr('style', 'min-height: 1px !important;');
	
				var numElem = 0;
				$elm.find("[id^='j-swiper-slide-']").each(function () {
					numElem++;
				});
				Logger.info('Te-Interesa: Número elementos: ' + numElem);
	
				var IntID = this.setTimer(numElem, $elm);
	
				$elm.find('.swiper-prev-row-bn').on('click', function () {
					Logger.info('Te-Interesa: Noticia anterior');
					clearInterval(IntID);
					IntID = _this3.setTimer(numElem, $elm);
					_this3.changeSlide('anterior', numElem, $elm);
				});
	
				$elm.find('.swiper-next-row-bn').on('click', function () {
					Logger.info('Te-Interesa: Noticia siguiente');
					clearInterval(IntID);
					IntID = _this3.setTimer(numElem, $elm);
					_this3.changeSlide('siguiente', numElem, $elm);
				});
			}
		}, {
			key: 'setTimer',
			value: function setTimer(numElem, $elm) {
				var _this4 = this;
	
				var i = setInterval(function () {
					Logger.info('Te-Interesa: setInterval - Noticia siguiente');
					_this4.changeSlide('interval', numElem, $elm);
				}, 7000); // 7000ms = 7 segartSlider, 4000);
				return i;
			}
		}, {
			key: 'changeSlide',
			value: function changeSlide(action, numElem, $elm) {
				var id = Voonto.$("[id^='j-swiper-slide-']:visible").data('pos');
				Logger.info('Te-Interesa: ID Visible: ' + id);
	
				var newId = id - 1;
				if (action === 'anterior') {
					if (id <= 1) {
						return false;
					}
				} else {
					newId = id + 1;
					if (action === 'interval') {
						if (id === numElem) {
							newId = 1;
							id = 1;
						}
					}
	
					if (id >= numElem) {
						return false;
					}
				}
	
				$elm.find("[id^='j-swiper-slide-']").each(function (i, e) {
					if (newId === Voonto.$(e).data('pos')) {
						Voonto.$(e).show();
					} else {
						Voonto.$(e).hide();
					}
				});
			}
		}]);
	
		return TeInteresa;
	}();
	
	exports.default = TeInteresa;

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * Función para depurar posiciones de publicidad
	 */
	
	function debugVam($elm) {
	  $elm.each(function (i, v) {
	    try {
	      var $v = Voonto.$(v);
	      if ($v.data('debugVam')) {
	        return;
	      }
	
	      $v.data('debugVam', 1);
	      var media = window.vocento.config.vam.media;
	      var posiciones = void 0;
	      if (Voonto.is.mobile()) posiciones = media.posicion_mobile;else {
	        posiciones = media.posicion_desktop;
	      }
	
	      var position = v.getAttribute('data-voc-vam-position');
	      $v.html(position);
	      if (!$v.attr('id')) {
	        $v.attr('id', position + '-id');
	      }
	      var posicion = posiciones[position];
	      //Logger.debug(`[vam-debug] position: ${position}`, posicion);
	      if (position && posicion && posicion.dimensiones) {
	        var dims = JSON.parse(posicion.dimensiones);
	        var minDim = null;
	        var maxWidth = $(window).width();
	        var minHeight = 2000;
	        for (var _i = dims.length - 1; _i >= 0; _i--) {
	          if (maxWidth > dims[_i][0] && minHeight > dims[_i][1]) {
	            minDim = dims[_i];
	            minHeight = dims[_i][1];
	          }
	        }
	        if (minDim) {
	          //Logger.debug(`[vam-debug] position: ${position} - ${width}x${height}`, posicion);
	          $v.css({
	            "width": minDim[0] + "px", "height": minDim[1] + "px",
	            "background-color": "cyan", "text-align": "center",
	            "padding-top": "25px", "display": "block"
	          });
	        }
	      }
	    } catch (ex) {
	      Logger.error('[vam-debug] exception:', v, ex);
	    }
	  });
	  setTimeout(function () {
	    $elm.trigger('vam:slotrendered');
	  }, 3000);
	}
	
	function initVamDebug(app) {
	  debugVam(Voonto.$('[data-voc-vam]'));
	  app.on('voonto:reload', function (ev, elm) {
	    try {
	      debugVam(Voonto.$(elm).find('[data-voc-vam]'));
	    } catch (ex) {
	      Logger.error('[vam-debug] exception:', ex);
	    }
	  });
	}
	
	exports.default = initVamDebug;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.checkPushStatus = checkPushStatus;
	exports.subscribeToChannels = subscribeToChannels;
	function getPushStatusChecker(url, cb) {
	
	    var id = "pushStatusChecker";
	    var psc = document.querySelector("#" + id);
	    if (psc) {
	        return cb(psc);
	    }
	
	    psc = document.createElement("iframe");
	    psc.src = url;
	    psc.id = id;
	    psc.style.display = "none";
	    document.body.appendChild(psc);
	    setTimeout(function () {
	        cb(psc);
	    }, 2000);
	    setTimeout(function () {
	        psc.parentNode.removeChild(psc);
	    }, 4000);
	}
	
	function checkPushStatus(url, cb) {
	
	    getPushStatusChecker(url, function (psc) {
	
	        var prevHandler = window.onmessage;
	        var response = void 0;
	        window.onmessage = function (e) {
	            if (_typeof(e.data) === "object") {
	                response = Object.assign({}, e.data);
	            } else {
	                response = {
	                    permission: false
	                };
	            }
	            window.onmessage = prevHandler;
	            cb(response);
	        };
	        psc.contentWindow.postMessage("checkPushStatus", "*");
	    });
	}
	
	function subscribeToChannels(channels, success, error) {
	    success = typeof success == 'function' ? success : function () {};
	    error = typeof error == 'function' ? error : function () {};
	    navigator.indigitall.subscribe(channels, success, error);
	}
	
	function success(success) {
	    Logger.debug(success);
	}
	
	function error(error) {
	    Logger.debug(error);
	}

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var trackUtils = __webpack_require__(11);
	
	var SectionLoadUtils = function () {
	  function SectionLoadUtils() {
	    _classCallCheck(this, SectionLoadUtils);
	  }
	
	  _createClass(SectionLoadUtils, null, [{
	    key: 'changeUrl',
	
	
	    /**
	     * Only modify current url to section
	     * @param $elm
	     */
	    value: function changeUrl($elm) {
	      var section = $elm.data('section');
	      var segment = '';
	      if (section === 'main') {
	        segment = '/';
	      } else {
	        segment = $elm.data('section-url');
	      }
	      segment += window.location.search + window.location.hash;
	
	      history.replaceState({ "section": section }, section, segment);
	    }
	
	    /**
	     * Change section name in header
	     * @param $elm
	     */
	
	  }, {
	    key: 'changeSectionName',
	    value: function changeSectionName($elm) {
	      Logger.info('[Header][Sticky] Change section name');
	      if (Voonto.is.mobile() === true) {
	        var $stickySectionName = Voonto.$('.cabecera-sticky .nombre-seccion>a');
	        var nsChannel = window.vocento.tracking.comscore.voc_site;
	        var nsLinkname = window.vocento.tracking.comscore.voc_se;
	        var trackingMark = '#ns_campaign=logo-seccion&ns_mchannel=' + nsChannel + '&ns_source=portada.portada&ns_linkname=' + nsLinkname + '&ns_fee=0';
	
	        if ($elm.data('section') === 'main') {
	          $stickySectionName.attr("href", '/' + trackingMark);
	          $stickySectionName.text('Portada');
	        } else {
	          $stickySectionName.attr("href", $elm.data('section-url') + trackingMark);
	          $stickySectionName.text($elm.data('section-name'));
	        }
	      } else {
	        var _nsChannel = window.vocento.tracking.comscore.voc_site;
	
	        var _nsLinkname = window.vocento.tracking.comscore.voc_se;
	        if ($elm.data('section') === 'main') {
	          if (window.vocento.tracking.comscore.voc_s1.length > 0) {
	            _nsLinkname = _nsLinkname + '.' + window.vocento.tracking.comscore.voc_s1;
	          }
	        } else {
	          _nsLinkname = $elm.data('tracking').comscore.voc_se;
	          if ($elm.data('tracking').comscore.voc_s1.length > 0) {
	            _nsLinkname = _nsLinkname + '.' + $elm.data('tracking').comscore.voc_s1;
	          }
	        }
	
	        var _trackingMark = '#ns_campaign=logo-seccion&ns_mchannel=' + _nsChannel + '&ns_source=portada.portada&ns_linkname=' + _nsLinkname + '&ns_fee=0';
	
	        var _$stickySectionName = Voonto.$('.cabecera-sticky .titulo-seccion>a');
	        if ($elm.data('section') === 'main') {
	          _$stickySectionName.attr("href", '/' + _trackingMark);
	          _$stickySectionName.text('Portada');
	        } else {
	          _$stickySectionName.attr("href", $elm.data('section-url') + _trackingMark);
	          _$stickySectionName.text($elm.data('section-name'));
	        }
	      }
	    }
	
	    /**
	     * Unbind click on section title an bind on with last section
	     * @param $elm
	     */
	
	  }, {
	    key: 'onClickSectionName',
	    value: function onClickSectionName($elm) {
	      if (Voonto.is.desktop()) {
	        var $sectionName = $('.cabecera-sticky > span > .titulo-seccion');
	        $sectionName.off('click');
	        $sectionName.on('click', function () {
	          history.replaceState({ section: 'main', lastSectionView: $elm.data('section') }, 'main', '/' + window.location.search);
	        });
	      } else if (Voonto.is.mobile()) {
	        var _$sectionName = $('.nombre-seccion');
	        _$sectionName.off('click');
	        _$sectionName.on('click', function () {
	          history.replaceState({ section: 'main', lastSectionView: $elm.data('section') }, 'main', '/' + window.location.search);
	        });
	      }
	    }
	
	    /**
	     * Listen all click events to replace history
	     * @param $elm
	     */
	
	  }, {
	    key: 'onClickSetHistoryHome',
	    value: function onClickSetHistoryHome($elm) {
	      $elm.find('a').on('click', function () {
	        var $link = Voonto.$(this);
	        var target = $link.attr('target');
	        if (target && target !== '_self') {
	          return;
	        }
	
	        var lastSectionView = 'main';
	        var $parent = $link.closest("[data-section]");
	        if ($parent) {
	          lastSectionView = $parent.data('section');
	        }
	        history.replaceState({ section: 'main', lastSectionView: lastSectionView }, 'main', '/' + window.location.search);
	      });
	    }
	  }, {
	    key: 'onClickTerrazaHome',
	    value: function onClickTerrazaHome($elm) {
	      $elm.find('a').on('click', function () {
	        var $link = Voonto.$(this);
	        var target = $link.attr('target');
	        if (target && target !== '_self') {
	          return;
	        }
	
	        var lastSectionView = 'main';
	        var $prev = $link.parentsUntil('main').last().prev("[data-section]");
	        if ($prev) {
	          lastSectionView = $prev.data('section');
	        }
	
	        history.replaceState({ section: 'main', lastSectionView: lastSectionView }, 'main', '/' + window.location.search);
	      });
	    }
	  }, {
	    key: 'onClickSectionMenu',
	    value: function onClickSectionMenu($elm) {
	      $elm.on('click', function () {
	        $elm.next().slideToggle();
	      });
	
	      $elm.on('click', function () {
	        var tipoAnimacion = $elm.data('boton-animado');
	        Logger.info('tipoAnimacion ' + tipoAnimacion);
	        switch (tipoAnimacion) {
	          case 'menu':
	            $elm.toggleClass('abierto');
	        }
	      });
	    }
	  }, {
	    key: 'onClickMainHome',
	    value: function onClickMainHome($elm) {
	      $elm.find('a').on('click', function () {
	        window.scrollTo(0, 0);
	        location.reload();
	      });
	    }
	
	    /** populate vars into global scope and track with vtm */
	
	  }, {
	    key: 'tracking',
	    value: function tracking($elm) {
	      try {
	        var tracking = null;
	
	        /** if is section, get tracking from data */
	        if ($elm.data('section') !== 'main' && typeof $elm.data('tracking') !== 'undefined') {
	          tracking = $elm.data('tracking');
	        }
	
	        /** if is main section, get data from main object */
	        if ($elm.data('section') === 'main') {
	          tracking = window.vocento.tracking;
	        }
	
	        Logger.info('Tracking section: ' + $elm.data('section'));
	
	        Voonto.getInstance().when('vtm:ready').then(function () {
	          TagManager.set({
	            seccion: tracking.comscore.voc_se,
	            subseccion1: tracking.comscore.voc_s1,
	            subseccion2: tracking.comscore.voc_s2,
	            subseccion3: tracking.comscore.voc_s3,
	            subseccion4: tracking.comscore.voc_s4,
	            titular: tracking.comscore.voc_tn,
	            tipoDominio: tracking.comscore.voc_pr,
	            edicion: tracking.comscore.voc_ed,
	            tipoContenido: tracking.comscore.voc_tc,
	            tipoContenidoA: tracking.comscore.voc_tcnew,
	            plataformaContenido: tracking.comscore.voc_pl,
	            sistemaPublicacion: tracking.comscore.voc_pu,
	            fechaPrimeraPublicacion: tracking.comscore.voc_fep,
	            fechaModificacion: tracking.comscore.voc_fem,
	            idioma: tracking.comscore.voc_idi,
	            IDEvolok: tracking.comscore.voc_pw_pid,
	            firmaAutor: tracking.comscore.voc_au,
	            origenContenido: tracking.comscore.voc_or,
	            topics: tracking.comscore.voc_top,
	            scrollInfinito: true,
	            scrollInfinitoHome: $elm.data('section-seq'),
	            scrollDireccion: window.vocento.tracking.comscore.scrollDireccion
	
	          }).track();
	
	          Logger.info('VTM dataLayer');
	          Logger.info(TagManager.get());
	
	          /** GTM datalayer scroll push event */
	          window.dataLayer.push({ 'event': 'scrollview' });
	        }, function (reason) {
	          trackUtils.imgTrack('vtm-ready-error-section', reason);
	          Logger.error('Error while vtm:ready promise: ', reason);
	        });
	      } catch (ex) {
	        trackUtils.imgTrack('vtm-error-exception-section', ex);
	        Logger.error('Exception while tracking section: ', ex);
	      }
	    }
	
	    /**
	     * return true if is back view
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'isBackView',
	    value: function isBackView() {
	      return typeof history.state !== 'undefined' && history.state !== null && typeof history.state.lastSectionView !== 'undefined';
	    }
	  }, {
	    key: 'disableHomeTopAds',
	    value: function disableHomeTopAds() {
	      Voonto.$('[data-voc-vam-position]').each(function (k, v) {
	        var $v = Voonto.$(v);
	        $v.attr('data-voc-vam-position-back', $v.attr('data-voc-vam-position'));
	        $v.removeAttr('data-voc-vam').removeAttr('data-voc-vam-position');
	      });
	    }
	  }, {
	    key: 'enableHomeTopAds',
	    value: function enableHomeTopAds() {
	      Voonto.$('[data-voc-vam-position-back]').each(function (k, v) {
	        var $v = Voonto.$(v);
	        $v.attr('data-voc-vam-position', $v.attr('data-voc-vam-position-back'));
	        $v.attr('data-voc-vam', '');
	      });
	    }
	  }]);
	
	  return SectionLoadUtils;
	}();
	
	;
	
	exports.default = SectionLoadUtils;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	
	  /**
	   * write img element with error to track exceptions in kibana
	   * @param key
	   * @param message
	   * @return {HTMLImageElement}
	   */
	  imgTrack: function imgTrack(key, message) {
	    var today = new Date(),
	        date = today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate(),
	        time = today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds(),
	        dateTime = date + '-' + time,
	        src = '/comun/img/dtm-track.jpg',
	        querystring = encodeURI('key=' + key + '&datetime=' + dateTime + '&message=' + message),
	        img = document.createElement('img');
	    img.src = src + '?' + querystring;
	    return img;
	  },
	  exportRootVars: function exportRootVars() {
	    for (var key in window.vocento.tracking.root) {
	      if (vocento.tracking.root.hasOwnProperty(key)) {
	        window[key] = vocento.tracking.root[key];
	      }
	    }
	  },
	  exportComscoreVars: function exportComscoreVars() {
	    /** solo exportamos algunas variables, ya que VTM tiene prioridad sobre las vocvars y pisariamos sus valores */
	    window.voc_ate = window.vocento.tracking.comscore.voc_ate;
	    window.voc_top = window.vocento.tracking.comscore.voc_top;
	    window.voc_site = window.vocento.tracking.comscore.voc_site;
	    window.voc_tcnew = window.vocento.tracking.comscore.voc_tcnew;
	    window.voc_tc = window.vocento.tracking.comscore.voc_tc;
	    window.voc_se = window.vocento.tracking.comscore.voc_se;
	    window.voc_au = window.vocento.tracking.comscore.voc_au;
	    window.voc_s1 = window.vocento.tracking.comscore.voc_s1;
	    window.voc_s2 = window.vocento.tracking.comscore.voc_s2;
	    window.voc_s3 = window.vocento.tracking.comscore.voc_s3;
	    window.voc_s4 = window.vocento.tracking.comscore.voc_s4;
	    window.voc_npc = window.vocento.tracking.comscore.voc_npc;
	  },
	  setTrackBuscadorPlaySummum: function setTrackBuscadorPlaySummum(TagManager) {
	    var main = window.document.getElementsByTagName('main');
	    if (main.length > 0) {
	      var keywords = main[0].getAttribute('data-keywords');
	      var num_entries = main[0].getAttribute('data-num-entries');
	      var buscador = main[0].getAttribute('data-buscador');
	      if (keywords !== null && keywords !== '') {
	        TagManager.set({
	          keyword: this.kebabCase(keywords),
	          tipoBuscador: 'buscador-' + buscador,
	          errorBusqueda: num_entries == 0 ? 'la-busqueda-no-obtuvo-ningun-resultado' : '',
	          nResultados: num_entries
	        });
	      }
	    }
	  },
	  kebabCase: function kebabCase(string) {
	    var result = string;
	    // Convert camelCase capitals to kebab-case.
	    result = result.replace(/([a-z][A-Z])/g, function (match) {
	      return match.substr(0, 1) + '-' + match.substr(1, 1).toLowerCase();
	    });
	    // Convert non-camelCase capitals to lowercase.
	    result = result.toLowerCase();
	    // Convert non-alphanumeric characters to hyphens
	    result = result.replace(/[^-a-z0-9]+/g, '-');
	    // Remove hyphens from both ends
	    result = result.replace(/^-+/, '').replace(/-$/, '');
	    return result;
	  }
	};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.recalBody = recalBody;
	exports.initSticky = initSticky;
	exports.recalcSticky = recalcSticky;
	var app = Voonto.getInstance();
	var libPath = app.lookup('vocento.config.nibara').libPath;
	if (libPath === undefined) {
	    throw 'nibara libPath config is empty';
	}
	
	var cargaSticky = false,
	    tamBody = 0,
	    tamColC = Voonto.$('.mas-contenido-articulo').height();
	;
	function recalBody() {
	    if (typeof Voonto.$('.hueco-imagen-principal ').height() === 'number') {
	        tamBody = Voonto.$('.hueco-imagen-principal ').height() + Voonto.$('.cuerpo-texto').height();
	    } else {
	        tamBody = Voonto.$('.cuerpo-texto').height();
	    }
	    Logger.info('[Sticky] recalBody tamBody: ' + tamBody + ' tamColC: ' + tamColC);
	}
	
	function initSticky() {
	    Logger.info('[Sticky] Function initSticky');
	    recalBody();
	    if (tamBody >= tamColC && !cargaSticky) {
	        app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(function () {
	            Logger.info('[Sticky] initSticky');
	            Voonto.$('[data-sticky-spacer]').each(function (i, e) {
	                var spacer = Voonto.$(e).parent().data('spacer');
	                if (typeof spacer !== 'undefined') {
	                    Logger.info('[Sticky] spacer: .', spacer);
	                    Voonto.$(e).stick_in_parent({
	                        offset_top: 20,
	                        spacer: '.' + spacer
	                    });
	                }
	            });
	            cargaSticky = true;
	        });
	    }
	    Logger.info('[Sticky] CargaSticky', cargaSticky);
	}
	
	function recalcSticky() {
	    Logger.info('[Sticky] Function recalcSticky');
	    recalBody();
	    if (tamBody >= tamColC) {
	        if (cargaSticky) {
	            Logger.info('[Sticky] recalcSticky');
	            Voonto.$('[data-sticky-spacer]').parent().attr('style', '');
	            Voonto.$(document.body).trigger('sticky_kit:recalc');
	        } else {
	            initSticky();
	        }
	    }
	}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.menusMobile = menusMobile;
	exports.menusDesktop = menusDesktop;
	
	var _vocuserNotifications = __webpack_require__(14);
	
	function menusMobile() {
	    var seccion = window.nibara.nTools.getSectionUrl();
	    Logger.debug('[menuMobile] seccion: ', seccion);
	    if (seccion === 'blogs') {
	        Voonto.$('.navegacion a.opinion').addClass('activo');
	        Voonto.$('.navegacion a.opinion').next().next().show();
	        Voonto.$('.navegacion a.opinion').next().addClass('rotado');
	    } else if (seccion !== 'summum' && seccion !== 'guia-restaurantes') {
	        Voonto.$('.navegacion a').removeClass('activo');
	    }
	
	    var navID = $('body').data('edicion');
	    /*if (navID) {
	      Voonto.$('.navegacion a.' + navID).addClass('activo');
	      Voonto.$('.navegacion a.' + navID).next().next().show();
	    }*/
	    Voonto.$('[data-abre-navegacion]').click(function () {
	        Voonto.$('.navegacion').stop().animate({ right: '0' }, 350, 'linear');
	    });
	    Voonto.$('[data-cierra-navegacion]').click(function () {
	        Voonto.$('.navegacion').stop().animate({ right: '100%' }, 350, 'linear');
	    });
	    Voonto.$('[data-abre-siguiente]').click(function () {
	        Voonto.$(this).next().slideToggle();
	        Voonto.$(this).toggleClass('rotado');
	    });
	    Voonto.$('[data-boton-animado]').on('click', function () {
	        var tipoAnimacion = Voonto.$(this).data('boton-animado');
	        Logger.info('tipoAnimacion ' + tipoAnimacion);
	        switch (tipoAnimacion) {
	            case 'menu':
	                Voonto.$(this).toggleClass('abierto');
	        }
	    });
	
	    /** menu usuario y alertas function *******************************************************/
	    Voonto.$('[data-abre-menu-usuario-login]').click(function () {
	        Voonto.$('[data-menu-usuario-login]').addClass('visible');
	        Voonto.$('[data-menu-alerta-login]').removeClass('visible');
	    });
	    Voonto.$('[data-abre-menu-alerta-login]').click(function () {
	        (0, _vocuserNotifications.listNotifications)().then(function () {
	            Voonto.$('[data-menu-usuario-login]').removeClass('visible');
	            Voonto.$('[data-menu-alerta-login]').addClass('visible');
	        });
	    });
	    Voonto.$('[data-cerrar-menu-usuario-login]').click(function () {
	        Voonto.$('[data-menu-usuario-login]').removeClass('visible');
	    });
	    Voonto.$('[data-cerrar-menu-alerta-login]').click(function () {
	        Voonto.$('[data-menu-alerta-login]').removeClass('visible');
	    });
	}
	
	function menusDesktop() {
	    Logger.info('[post-script] Init menusDesktop');
	    var seccion = window.nibara.nTools.getSectionUrl();
	    Logger.info('[post-script] seccion: ' + seccion);
	
	    var app = Voonto.getInstance();
	    var siteType = app.lookup('vocento.site').type;
	    if (siteType !== undefined) {
	        Voonto.$('.main .titulo-seccion').css({
	            'top': '-61px',
	            'opacity': 1
	        });
	    } else {
	        if (Voonto.$('.segundo-nivel').length && seccion !== 'summum') {
	            Voonto.$('.main .titulo-seccion').css({
	                'top': '-91px',
	                'opacity': 1
	            });
	        } else {
	            Voonto.$('.main .titulo-seccion').css('opacity', 1);
	        }
	    }
	
	    Voonto.$('[data-mostrar]').on('click', function () {
	        if (Voonto.$(this).data('mostrar') !== '') {
	            Voonto.$(this).next().css('display', Voonto.$(this).data('mostrar'));
	        } else {
	            Voonto.$(this).next().show();
	        }
	    });
	
	    Voonto.$('[data-cerrar]').on('click', function () {
	        Voonto.$(this).parent().hide();
	    });
	
	    /** menu usuario y alertas function *******************************************************/
	    var botonUsuarioLogin = Voonto.$('[data-abre-menu-usuario-login]'),
	        botonAlertaLogin = Voonto.$('[data-abre-menu-alerta-login]'),
	        menuUsuarioLogin = Voonto.$('[data-menu-usuario-login]'),
	        menuAlertaLogin = Voonto.$('[data-menu-alerta-login]'),
	        botonUsuarioLoginSticky = Voonto.$('[data-abre-menu-usuario-login-sticky]'),
	        botonAlertaLoginSticky = Voonto.$('[data-abre-menu-alerta-login-sticky]'),
	        menuUsuarioLoginSticky = Voonto.$('[data-menu-usuario-login-sticky]'),
	        menuAlertaLoginSticky = Voonto.$('[data-menu-alerta-login-sticky]');
	
	    botonUsuarioLogin.on('click', function () {
	        Logger.info('[post-script] botonUsuarioLogin click');
	        Logger.info('[post-script] botonUsuarioLogin: ' + botonUsuarioLogin);
	        if (menuUsuarioLogin.hasClass('visible')) {
	            Logger.info('[post-script] menuUsuarioLogin has class visible');
	            Voonto.$(this).removeClass('visible');
	            menuUsuarioLogin.removeClass('visible');
	        } else {
	            Logger.info('[post-script] menuUsuarioLogin not class visible');
	            Voonto.$(this).addClass('visible');
	            menuUsuarioLogin.addClass('visible');
	            botonAlertaLogin.removeClass('visible');
	            menuAlertaLogin.removeClass('visible');
	        }
	    });
	
	    botonAlertaLogin.on('click', function () {
	        Logger.info('[post-script] botonAlertaLogin click');
	        if (menuAlertaLogin.hasClass('visible')) {
	            Voonto.$(this).removeClass('visible');
	            menuAlertaLogin.removeClass('visible');
	        } else {
	            (0, _vocuserNotifications.listNotifications)().then(function () {
	                Logger.debug('[vocuser-notifications] cambio menu');
	                botonAlertaLogin.addClass('visible');
	                menuAlertaLogin.addClass('visible');
	                botonUsuarioLogin.removeClass('visible');
	                menuUsuarioLogin.removeClass('visible');
	            });
	        }
	    });
	
	    botonUsuarioLoginSticky.on('click', function () {
	        Logger.info('[post-script] botonUsuarioLoginSticky click');
	        if (menuUsuarioLoginSticky.hasClass('visible')) {
	            Voonto.$(this).removeClass('visible');
	            menuUsuarioLoginSticky.removeClass('visible');
	        } else {
	            Voonto.$(this).addClass('visible');
	            menuUsuarioLoginSticky.addClass('visible');
	            botonAlertaLoginSticky.removeClass('visible');
	            menuAlertaLoginSticky.removeClass('visible');
	        }
	    });
	
	    botonAlertaLoginSticky.on('click', function () {
	        Logger.info('[post-script] botonAlertaLoginSticky click');
	        if (menuAlertaLoginSticky.hasClass('visible')) {
	            Voonto.$(this).removeClass('visible');
	            menuAlertaLoginSticky.removeClass('visible');
	        } else {
	            (0, _vocuserNotifications.listNotifications)().then(function () {
	                botonAlertaLoginSticky.addClass('visible');
	                menuAlertaLoginSticky.addClass('visible');
	                botonUsuarioLoginSticky.removeClass('visible');
	                menuUsuarioLoginSticky.removeClass('visible');
	            });
	        }
	    });
	}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var app = Voonto.getInstance();
	
	var baseurl = '/ajax/v2/api/v1/';
	var vocUserNotificationsPath = app.lookup('vocento.config.nibara').vocUserNotifications;
	var host = window.location.host;
	if (vocUserNotificationsPath !== undefined) {
	    baseurl = vocUserNotificationsPath + baseurl;
	} else if ('abcblogs.abc.es' === host) {
	    baseurl = 'https://www.abc.es' + baseurl;
	}
	
	var checkNotifications = false;
	
	function notificationsLoad() {
	    countNotifications();
	
	    Voonto.$('.bloque-notificaciones, .notificaciones-capa').on('click', '.delete', function (ev) {
	        ev.preventDefault();
	        var id = Voonto.$(this).data('id');
	        var ids = [];
	        ids.push(id);
	        deleteNotifications(ids);
	    });
	
	    Voonto.$('.bloque-notificaciones, .notificaciones-capa').on('click', '.cuerpo-notificacion .titulo a', function (ev) {
	        ev.preventDefault();
	        ev.stopPropagation();
	        var id = Voonto.$(this).data('id');
	        var status = Voonto.$(this).data('status');
	        var url = Voonto.$(this).attr('href');
	        var ids = [];
	        ids.push(id);
	        if (status != 'read' && ids.length > 0) {
	            confirmClickedUrl(ids, url, status);
	        } else {
	            window.location.href = url;
	        }
	    });
	}
	
	function countNotifications() {
	
	    Voonto.$.ajax({
	        url: baseurl + 'notifications/count',
	        dataType: 'json',
	        xhrFields: {
	            withCredentials: true
	        },
	        timeout: 10000
	    }).fail(function (jqXHR, textStatus, errorThrown) {
	        Logger.error('count notifications: retrieve', textStatus);
	    }).done(function (response) {
	        if (response && 'undefined' !== typeof response.code && response.code === 200) {
	            if (response.count > 0) {
	                Logger.debug('[vocuser-notifications] count notifications', response.count);
	                Voonto.$('.user-logged-in > .alertas.notificaciones').append('<span class="globo">' + response.count + '</span>');
	            }
	        } else {
	            Logger.error('[vocuser-notifications] count notifications', response);
	        }
	    });
	}
	
	function countNotificationsR2() {
	    var daysRecents = 5;
	    var today = new Date();
	    var dateRecents = new Date(today.getTime() - daysRecents * 24 * 3600 * 1000);
	    Logger.debug('[post-script] Count notifications R2');
	    Logger.debug('[post-script] baseurl: ' + baseurl + 'notifications/list');
	    Voonto.$.ajax({
	        url: baseurl + 'notifications/list',
	        dataType: 'json',
	        xhrFields: {
	            withCredentials: true
	        },
	        timeout: 10000
	    }).fail(function (jqXHR, textStatus, errorThrown) {
	        Logger.error('count notifications: retrieve', textStatus);
	    }).done(function (response) {
	        if (response && 'undefined' !== typeof response.code && response.code === 200) {
	            if (response.list.length > 0) {
	                Logger.debug('[vocuser-notifications] count notifications all', response.list.length);
	                var recientes = [];
	                response.list.forEach(function (notification) {
	                    var notDate = notification['timestamp'].split(/[^0-9]/);
	                    var notificationDate = new Date(notDate[0], notDate[1] - 1, notDate[2], notDate[3], notDate[4], notDate[5]);
	                    if (dateRecents <= notificationDate && notification['status'] === 'received') {
	                        recientes.push(notification);
	                    }
	                });
	                Logger.debug('[vocuser-notifications] count notifications recents', recientes.length);
	                if (recientes.length > 0) {
	                    Voonto.$('.user-logged-in > .alertas.notificaciones').append('<span class="globo">' + recientes.length + '</span>');
	                }
	            }
	        } else {
	            Logger.error('[vocuser-notifications] count notifications', response);
	        }
	    });
	}
	
	function confirmNotifications(notifications, statusNotif) {
	
	    var events = [];
	    var status = '';
	
	    if (notifications.length > 0) {
	        events = notifications;
	        status = statusNotif;
	    } else {
	        /* confirmamos todas las notificaciones, enviamos el id de una para recibir el request no vacio */
	        var event = '0000';
	        events.push(event);
	        status = 'received,read';
	    }
	
	    var data = {
	        'notifications': events,
	        'status': status,
	        'all': 0
	    };
	    Logger.debug('[vocuser-notifications] confirm notifications ' + status, data);
	
	    Voonto.$.ajax({
	        type: 'post',
	        url: baseurl + 'notifications/confirm',
	        data: data,
	        dataType: 'json',
	        xhrFields: {
	            withCredentials: true
	        },
	        timeout: 10000
	    }).fail(function (jqXHR, textStatus, errorThrown) {
	        Logger.error('confirm notifications: retrieve', textStatus);
	    }).done(function (response) {
	        if (response && 'undefined' !== typeof response.code && response.code === 200) {
	            Logger.debug('[vocuser-notifications] confirm notifications OK');
	            Voonto.$('.user-logged-in > .alertas.notificaciones, .todas-notificaciones').find('.globo, .nuevo').remove();
	        } else {
	            Logger.error('[vocuser-notifications] confirm notifications', response);
	        }
	    });
	}
	
	function listNotifications() {
	    var hitsMenu = 4;
	    var daysRecents = 5;
	    var today = new Date();
	    var dateRecents = new Date(today.getTime() - daysRecents * 24 * 3600 * 1000);
	
	    return new Promise(function (resolve, reject) {
	
	        app.when('vocuser:ready').then(function (gigyaUX) {
	            Logger.debug('[vocuser-notifications listNotifications] gigyaUX');
	            var userType = gigyaUX.getUserType();
	            if (userType !== 'anonimo') {
	
	                Voonto.$.ajax({
	                    url: baseurl + 'notifications/list',
	                    dataType: 'json',
	                    xhrFields: {
	                        withCredentials: true
	                    },
	                    timeout: 10000
	                }).fail(function (jqXHR, textStatus, errorThrown) {
	                    Logger.error('list notifications: retrieve', textStatus);
	                    return reject(textStatus);
	                }).done(function (response) {
	                    if (response && 'undefined' !== typeof response.code && response.code === 200) {
	                        Logger.debug('[vocuser-notifications listNotifications] response', response);
	                        var notificationsUrl = [];
	                        var notificationsNoUrl = [];
	                        var $list = Voonto.$('.login-alerta > .notificaciones-capa');
	                        $list.children().remove();
	                        if (response.list.length > 0) {
	                            var recientes = [];
	                            var anteriores = [];
	                            response.list.forEach(function (notification) {
	                                if (notification['status'] == 'received') {
	                                    if (notification['content']['url'] != '') {
	                                        notificationsUrl.push(notification['id']);
	                                    } else {
	                                        notificationsNoUrl.push(notification['id']);
	                                    }
	                                }
	                            });
	                            response.list.slice(0, hitsMenu * 2).forEach(function (notification) {
	                                var notDate = notification['timestamp'].split(/[^0-9]/);
	                                var notificationDate = new Date(notDate[0], notDate[1] - 1, notDate[2], notDate[3], notDate[4], notDate[5]);
	                                if (dateRecents <= notificationDate) {
	                                    recientes.push(notification);
	                                } else {
	                                    anteriores.push(notification);
	                                }
	                            });
	                            if (recientes.length > 0) {
	                                $list.append('<section class="zona-notificaciones">' + '<h4 class="subtitulo-area">Recientes</h4>' + '<span class="bloque-notificaciones">');
	                                recientes.slice(0, hitsMenu).forEach(function (notification) {
	                                    displayNotification($list.find('.bloque-notificaciones'), notification);
	                                });
	                                $list.append('</span></section>');
	                            }
	                            if (anteriores.length > 0 && recientes.length < hitsMenu) {
	                                $list.append('<section class="zona-notificaciones secundario">' + '<h4 class="subtitulo-area secundario">Anteriores</h4>' + '<span class="bloque-notificaciones">');
	                                var items = recientes.length;
	                                anteriores.slice(0, hitsMenu).forEach(function (notification) {
	                                    if (items < hitsMenu) {
	                                        displayNotification($list.find('.secundario .bloque-notificaciones'), notification);
	                                        items = items + 1;
	                                    }
	                                });
	                                $list.append('</span></section>');
	                            }
	
	                            $list.append('<span class="botonera derecha">' + '<a class="boton" href="/micuenta/notificaciones/">' + '<span class="accion">Ver todas</span>' + '<span class="icono">' + '<svg viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path></svg>' + '</span>' + '</a>' + '</span>');
	                        } else {
	                            $list.append('<span class="notificacion fecha">No tienes ninguna notificación pendiente</span>');
	                        }
	                        if (notificationsUrl.length > 0) {
	                            confirmNotifications(notificationsUrl, 'received,pending');
	                        }
	                        if (notificationsNoUrl.length > 0) {
	                            confirmNotifications(notificationsNoUrl, 'received,read');
	                        }
	                        return resolve();
	                    } else {
	                        Logger.error('[vocuser-notifications] list notifications', response);
	                        return reject('Invalid response');
	                    }
	                });
	            } else {
	                return resolve();
	            }
	        });
	
	        function displayNotification($list, notification) {
	            var type = '';
	            var mchannel = void 0,
	                source = void 0,
	                linkname = void 0,
	                vtmInfo = '';
	            var title = 'Noticia';
	            if (notification['content']['contentType'] == 'concurso' || notification['content']['contentType'] == 'evento') {
	                type = 'evento';
	                title = 'Concurso';
	            } else if (notification['content']['contentType'] == 'encuesta') {
	                type = 'encuesta';
	                title = 'Encuesta';
	            }
	            if (notification['content']['url'].includes('/opinion/')) {
	                title = 'Opinión';
	            }
	            if (notification['content']['contentType'] == 'noticia') {
	                mchannel = 'autor';
	            } else {
	                mchannel = 'manual';
	            }
	            if (mchannel == 'autor') {
	                source = notification['content']['categoryId'];
	                linkname = notification['content']['author']['name'].toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-');
	                vtmInfo = mchannel + '-' + linkname;
	            } else {
	                source = notification['content']['contentId'];
	                linkname = notification['content']['contentType'];
	                vtmInfo = mchannel + '-' + source + '-' + linkname;
	            }
	            var tagging = '#ns_campaign=area-usuario-notif&ns_mchannel=' + mchannel + '&ns_source=' + source + '&ns_linkname=' + linkname + '&ns_fee=0';
	            var authorBottom = '';
	
	            if (notification['content'].hasOwnProperty('interests') && notification['content']['interests'].length > 0) {
	                if (notification['content']['interests'][0]['name'] !== '') {
	                    authorBottom = notification['content']['interests'][0]['name'];
	                } else if (notification['content']['interests'][0]['subcategory_name'] != 'General') {
	                    authorBottom = notification['content']['interests'][0]['category_name'] + ' - ' + notification['content']['interests'][0]['subcategory_name'];
	                } else {
	                    authorBottom = notification['content']['interests'][0]['category_name'];
	                }
	            }
	            if (notification['content']['url'] != '') {
	                $list.append('<article class="tarjeta-notificacion' + (notification['status'] !== 'read' ? ' nueva' : '') + (notification['content']['url'].includes('/opinion/') ? ' opinion' : '') + (type != '' ? ' ' + type : '') + '">' + '<header><span class="tipo">' + title + '</span><span class="interes">' + (authorBottom != '' ? 'en ' + authorBottom : 'por ' + notification['content']['author']['name']) + '</span></header>' + '<span class="cuerpo-notificacion">' + '<h5 class="titulo"><a data-id="' + notification['id'] + '" data-status="' + notification['status'] + '" href="' + notification['content']['url'] + tagging + '" title="' + notification['content']['title'] + '" data-voc-vtm-id="au-notific-click" data-voc-vtm-info="' + vtmInfo + '">' + notification['content']['title'] + '</a></h5>' + (authorBottom != '' ? '<span class="data">' + notification['content']['author']['name'] + '</span>' : '') + '</span>' + '<footer>' + '<span class="fecha">' + dateFormat(notification['timestamp']) + '</span>' + '<span class="boton">' + '<span class="accion delete" data-id="' + notification['id'] + '" data-voc-vtm-id="au-notific-eliminar" data-voc-vtm-info="' + vtmInfo + '">Eliminar</span>' + '</span>' + '</footer>' + '</article>');
	            } else {
	                $list.append('<article class="tarjeta-notificacion' + (notification['status'] !== 'read' ? ' nueva' : '') + (notification['content']['url'].includes('/opinion/') ? ' opinion' : '') + (type != '' ? ' ' + type : '') + '">' + '<header><span class="tipo">' + title + '</span><span class="interes">' + (authorBottom != '' ? 'en ' + authorBottom : 'por ' + notification['content']['author']['name']) + '</span></header>' + '<span class="cuerpo-notificacion">' + '<h5 class="titulo">' + notification['content']['title'] + '</h5>' + (authorBottom != '' ? '<span class="data">' + notification['content']['author']['name'] + '</span>' : '') + '</span>' + '<footer>' + '<span class="fecha">' + dateFormat(notification['timestamp']) + '</span>' + '<span class="boton">' + '<span class="accion delete" data-id="' + notification['id'] + '" data-voc-vtm-id="au-notific-eliminar" data-voc-vtm-info="' + vtmInfo + '">Eliminar</span>' + '</span>' + '</footer>' + '</article>');
	            }
	        }
	
	        function dateFormat(fecha) {
	            if (Voonto.is.safari()) {
	                fecha = fecha.replace(/(\+\d\d)(\d\d)/, function (a, b, c) {
	                    return b + ':' + c;
	                });
	            }
	
	            var date = new Date(fecha);
	            Number.prototype.padLeft = function (base, chr) {
	                var len = String(base || 10).length - String(this).length + 1;
	                return len > 0 ? new Array(len).join(chr || '0') + this : this;
	            };
	            var dformat = [date.getDate().padLeft(), (date.getMonth() + 1).padLeft(), date.getFullYear()].join('-') + ' ' + [date.getHours().padLeft(), date.getMinutes().padLeft(), date.getSeconds().padLeft()].join(':');
	
	            return dformat;
	        }
	    });
	}
	
	function deleteNotifications(ids) {
	    var data = { 'notifications': ids };
	    Logger.debug('[vocuser-notifications] delete notifications', data);
	
	    Voonto.$.ajax({
	        type: 'post',
	        url: baseurl + 'notifications/delete',
	        data: data,
	        dataType: 'json',
	        xhrFields: {
	            withCredentials: true
	        },
	        timeout: 10000
	    }).fail(function (jqXHR, textStatus, errorThrown) {
	        Logger.error('delete notifications: retrieve', textStatus);
	    }).done(function (response) {
	        if (response && 'undefined' !== typeof response.code && response.code === 200) {
	            Logger.debug('[vocuser-notifications] delete notifications OK');
	            ids.forEach(function (id) {
	                Voonto.$('.bloque-notificaciones [data-id=' + id + ']').closest('article').remove();
	            });
	            checkNotificationsEmpty();
	        } else {
	            Logger.error('[vocuser-notifications] delete notifications', response);
	        }
	    });
	}
	
	function confirmClickedUrl(ids, url, status) {
	
	    var data = {
	        'notifications': ids,
	        'status': status + ',read',
	        'all': 0
	    };
	    Logger.debug('[vocuser-notifications] confirm clicked url', data);
	
	    Voonto.$.ajax({
	        type: 'post',
	        url: baseurl + 'notifications/confirm',
	        data: data,
	        dataType: 'json',
	        xhrFields: {
	            withCredentials: true
	        },
	        timeout: 10000
	    }).fail(function (jqXHR, textStatus, errorThrown) {
	        Logger.error('confirm clicked url: retrieve', textStatus);
	    }).done(function (response) {
	        if (response && 'undefined' !== typeof response.code && response.code === 200) {
	            Logger.debug('[vocuser-notifications] confirm clicked url OK');
	            window.location.href = url;
	        } else {
	            Logger.error('[vocuser-notifications] delete notifications', response);
	        }
	    });
	}
	
	function checkNotificationsEmpty() {
	    var $list = Voonto.$('.notificaciones-capa');
	    var $listwebpage = Voonto.$('.completa').last();
	    Logger.debug('[vocuser-notifications] checkNotificationsEmpty', $list);
	
	    if ($list.find('.bloque-notificaciones').children('article').length === 0) {
	        $list.children().remove();
	        $list.append('<span class="notificacion fecha">No tienes ninguna notificación pendiente</span>');
	    }
	    if ($listwebpage.find('.bloque-notificaciones').children('article').length === 0) {
	        $listwebpage.find('.bloque-notificaciones').closest('.completa').children().remove();
	        Logger.debug('[vocuser-notifications] checkNotificationsEmpty webpage', $listwebpage.length);
	        $listwebpage.append('<span class="mensaje">No tienes ninguna notificación pendiente</span>');
	    }
	}
	
	exports.notificationsLoad = notificationsLoad;
	exports.listNotifications = listNotifications;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stickyHeaderMobile = stickyHeaderMobile;
	exports.stickyHeaderDesktop = stickyHeaderDesktop;
	function stickyHeaderMobile() {
	  var posicionAnterior = 0;
	  var posCabecera = 'suelta';
	  var estadoCabecera = 'visible';
	
	  var navPortada = document.querySelector('body>.navegacion');
	  var cabeceraPortada = document.querySelector('body>.cabecera');
	
	  function fijarCabeceraSticky() {
	    if (cabeceraPortada.parentElement.classList.contains('portada') || cabeceraPortada.parentElement.classList.contains('subportada')) {
	      cabeceraPortada.classList.add('a-portada-seccion');
	    }
	    cabeceraPortada.classList.add('cabecera-sticky');
	    cabeceraPortada.previousElementSibling.style.marginBottom = '50px';
	    return 'fija';
	  }
	
	  function soltarCabeceraSticky() {
	    if (cabeceraPortada.parentElement.classList.contains('portada') || cabeceraPortada.parentElement.classList.contains('subportada')) {
	      cabeceraPortada.classList.remove('a-portada-seccion');
	    }
	    cabeceraPortada.classList.remove('cabecera-sticky');
	    cabeceraPortada.previousElementSibling.style.marginBottom = '0px';
	    return 'suelta';
	  }
	
	  function cabeceraStickyVisible() {
	    cabeceraPortada.classList.add('visible');
	    return 'visible';
	  }
	
	  function cabeceraStickyOculta() {
	    cabeceraPortada.classList.remove('visible');
	    return 'noVisible';
	  }
	
	  if (navPortada && cabeceraPortada) {
	    var delay = false;
	    var posicionCabecera = cabeceraPortada.offsetTop + cabeceraPortada.offsetHeight;
	    setTimeout(function () {
	      document.addEventListener('scroll', function () {
	        if (delay) return;
	        if (window.scrollY > posicionCabecera) {
	          if (posCabecera === 'suelta') posCabecera = fijarCabeceraSticky();
	          if (window.scrollY > posicionAnterior && estadoCabecera === 'visible') {
	            estadoCabecera = cabeceraStickyOculta();
	          }
	          if (window.scrollY < posicionAnterior && estadoCabecera === 'noVisible') {
	            estadoCabecera = cabeceraStickyVisible();
	          }
	        } else if (window.scrollY < posicionCabecera - cabeceraPortada.offsetHeight || window.scrollY == 0) {
	          if (posCabecera === 'fija') {
	            posCabecera = soltarCabeceraSticky();
	            estadoCabecera = cabeceraStickyOculta();
	          }
	        }
	        posicionAnterior = window.scrollY;
	        delay = true;
	        setTimeout(function () {
	          delay = false;
	          if (window.scrollY == 0) posCabecera = soltarCabeceraSticky();
	        }, 50);
	      });
	    }, 500);
	  }
	}
	
	function stickyHeaderDesktop() {
	  var navPortada = document.querySelector('body>.navegacion');
	  var menuStickyPortada = document.querySelector('.cabecera-sticky');
	  var capaMenu = document.querySelector('.cabecera-sticky .capa-todo');
	  var botonUsuarioLogin = document.querySelector('[data-abre-menu-usuario-login]'),
	      menuUsuarioLogin = document.querySelector('[data-menu-usuario-login]'),
	      botonAlertaLogin = document.querySelector('[data-abre-menu-alerta-login]'),
	      menuAlertaLogin = document.querySelector('[data-menu-alerta-login]'),
	      botonUsuarioLogout = document.querySelector('[data-abre-menu-usuario-logout]'),
	      botonUsuarioLoginSticky = document.querySelector('[data-abre-menu-usuario-login-sticky]'),
	      botonUsuarioLogoutSticky = document.querySelector('[data-abre-menu-usuario-logout-sticky]'),
	      menuUsuarioLoginSticky = document.querySelector('[data-menu-usuario-login-sticky]'),
	      botonAlertaLoginSticky = document.querySelector('[data-abre-menu-alerta-login-sticky]'),
	      menuAlertaLoginSticky = document.querySelector('[data-menu-alerta-login-sticky]');
	
	  function cabeceraStickyVisible() {
	    menuStickyPortada.classList.add('visible');
	    if (menuUsuarioLogin) {
	      menuUsuarioLogin.classList.remove('visible');
	    }
	    if (menuAlertaLogin) {
	      menuAlertaLogin.classList.remove('visible');
	    }
	    if (botonUsuarioLogin) {
	      botonUsuarioLogin.classList.remove('visible');
	    }
	    if (botonUsuarioLogout) {
	      botonUsuarioLogout.classList.remove('visible');
	    }
	    if (botonAlertaLogin) {
	      botonAlertaLogin.classList.remove('visible');
	    }
	    return 'visible';
	  }
	
	  function cabeceraStickyOculta() {
	    menuStickyPortada.classList.remove('visible');
	    capaMenu.style.display = 'none';
	    if (menuUsuarioLoginSticky) {
	      menuUsuarioLoginSticky.classList.remove('visible');
	    }
	    if (menuAlertaLoginSticky) {
	      menuAlertaLoginSticky.classList.remove('visible');
	    }
	    if (botonUsuarioLoginSticky) {
	      botonUsuarioLoginSticky.classList.remove('visible');
	    }
	    if (botonUsuarioLogoutSticky) {
	      botonUsuarioLogoutSticky.classList.remove('visible');
	    }
	    if (botonAlertaLoginSticky) {
	      botonAlertaLoginSticky.classList.remove('visible');
	    }
	    return 'oculta';
	  }
	
	  if (capaMenu && navPortada && menuStickyPortada) {
	    var delay = false;
	    //if(capaMenu.previousElementSibling.classList.contains('todo')) capaMenu.previousElementSibling.addEventListener('click',function(){capaMenu.style.display = 'flex'});
	    var posicionNavPortada = navPortada.getBoundingClientRect().bottom > 0 ? cabeceraStickyOculta() : cabeceraStickyVisible();
	    document.addEventListener('scroll', function () {
	      if (delay) return;
	      if (navPortada.getBoundingClientRect().bottom <= 0 && posicionNavPortada == 'oculta') {
	        posicionNavPortada = cabeceraStickyVisible();
	      }
	      if (navPortada.getBoundingClientRect().top > 0 && posicionNavPortada == 'visible') {
	        posicionNavPortada = cabeceraStickyOculta();
	      }
	      delay = true;
	      setTimeout(function () {
	        delay = false;
	      }, 100);
	    });
	  }
	}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $document = Voonto.$(document),
	    redesSticky = document.querySelector('.herramientas.fija'),
	    marcador = document.querySelector('.marcador');
	var redes = redesSticky ? redesSticky.nextElementSibling : null;
	var estadoRedes = 'relativo';
	
	function redesFijo() {
	    redesSticky.classList.add('redesVisible');
	    return 'fijo';
	}
	
	function redesRelativo() {
	    redesSticky.classList.remove('redesVisible');
	    return 'relativo';
	}
	
	var handleScroll = nibara.nTools.throttle(50, function handleScroll() {
	    //Logger.info('SocialToolbar handleScroll');
	
	    var bottom = redes.getBoundingClientRect().bottom;
	    var offset = marcador ? marcador.offsetHeight : 0;
	    if (bottom <= offset && estadoRedes === 'relativo') {
	        estadoRedes = redesFijo();
	    }
	    if (bottom > offset && estadoRedes === 'fijo') {
	        estadoRedes = redesRelativo();
	    }
	});
	
	var SocialToolbar = function () {
	    function SocialToolbar(form) {
	        _classCallCheck(this, SocialToolbar);
	
	        this.isEnabled = false;
	    }
	
	    _createClass(SocialToolbar, [{
	        key: 'enable',
	        value: function enable() {
	            Logger.info('SocialToolbar enable. isEnabled: ' + this.isEnabled);
	            if (redesSticky && redes && !this.isEnabled) {
	                handleScroll();
	                $document.on('scroll', handleScroll);
	                this.isEnabled = true;
	            }
	        }
	    }, {
	        key: 'disable',
	        value: function disable() {
	            Logger.info('SocialToolbar disable. isEnabled: ' + this.isEnabled);
	            if (this.isEnabled) {
	                $document.off('scroll', handleScroll);
	                this.isEnabled = false;
	                redesSticky.classList.remove('redesVisible');
	            }
	        }
	    }]);
	
	    return SocialToolbar;
	}();
	
	exports.default = SocialToolbar;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// layout-script.js